/**
 * InsulaCharter - Lokalisierung Deutsch
 * Angepasst von AlguerHouse für Bootsverleih
 */

const de = {
  // ============================================
  // MARKUP INCLUSIVE (Anfrage/Genehmigung)
  // ============================================
  markupInclusive: {
    title: 'Inklusivpreise',
    subtitle: 'Beantragen, dass der Plattform-Aufschlag im angezeigten Preis enthalten ist',
    rental: 'Vermietung',
    excursion: 'Ausflüge',
    statusActive: 'Aktiv',
    statusPending: 'Warten auf Genehmigung',
    statusInactive: 'Nicht aktiv',
    request: 'Anfragen',
    requested: 'Anfrage gesendet',
    requestError: 'Fehler beim Senden der Anfrage',
    approve: 'Genehmigen',
    reject: 'Ablehnen',
    approved: 'Anfrage genehmigt',
    rejected: 'Anfrage abgelehnt',
    actionError: 'Fehler bei der Aktion',
    adminTitle: 'Inklusiv-Aufschlag',
    adminHint: 'Inklusivpreis-Anfragen pro Bereich genehmigen oder ablehnen.',
    vendorHint: 'Bis zur Genehmigung bleibt der Preis additiv (Aufschlag separat).',
  },
  // ============================================
  // METADATA & SEO
  // ============================================
  metadata: {
    siteTitle: 'InsulaCharter - Bootsverleih auf Sardinien',
    siteDescription: 'Finden Sie das perfekte Boot für Ihr Abenteuer im kristallklaren Wasser der Costa Smeralda und den Buchten Sardiniens.',
    loginTitle: 'Anmelden - InsulaCharter',
    loginDescription: 'Melden Sie sich bei Ihrem InsulaCharter-Konto an',
    registerTitle: 'Registrieren - InsulaCharter',
    registerDescription: 'Erstellen Sie Ihr InsulaCharter-Konto',
  },

  // ============================================
  // COMMON / SHARED
  // ============================================
  common: {
    all: 'Alle',
    loading: 'Laden...',
    error: 'Fehler',
    errorPrefix: 'Fehler: ',
    serverError: 'Serverfehler',
    cancel: 'Abbrechen',
    confirm: 'Bestätigen',
    success: 'Erfolgreich',
    save: 'Speichern',
    saving: 'Speichern...',
    create: 'Erstellen',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    search: 'Suchen',
    searchNow: 'JETZT SUCHEN',
    back: 'Zurück',
    next: 'Weiter',
    close: 'Schließen',
    yes: 'Ja',
    no: 'Nein',
    free: 'Kostenlos',
    included: 'Inklusive',
    day: 'Tag',
    days: 'Tage',
    guest: 'Passagier',
    guests: 'Passagiere',
    passengers: 'Passagiere',
    boat: 'Boot',
    meters: 'Meter',
    person: 'Person',
    persons: 'Personen',
    total: 'Gesamt',
    price: 'Preis',
    perDay: '/Tag',
    today: 'Heute',
    uploading: 'Hochladen...',
    sending: 'Senden...',
    hour: 'Stunde',
    hours: 'Stunden',
    loginRequired: 'Anmeldung erforderlich',
    from: 'Ab',
  },

  // ============================================
  // NAVBAR
  // ============================================
  navbar: {
    logo: 'InsulaCharter',
    maintenanceMode: 'WARTUNGSMODUS - Die Seite ist nur für Sie sichtbar',
    maintenanceShort: 'WARTUNG',
    exitMaintenance: 'Beenden',
    accountActive: 'Konto Aktiv',
    roleHost: 'Eigner',
    roleGuest: 'Gast',
    adminPanel: 'Dashboard',
    adminSettings: 'Einstellungen',
    myTrips: 'Meine Mieten',
    myRequests: 'Meine Anfragen',
    logout: 'Abmelden',
    login: 'Anmelden',
  },

  // ============================================
  // FOOTER
  // ============================================
  footer: {
    description: 'Exklusive Bootserlebnisse auf Sardinien, mit Leidenschaft kuratiert, um Ihnen maximalen Komfort auf dem Meer zu garantieren.',
    quickLinks: 'Schnelllinks',
    exploreBoats: 'Flotte entdecken',
    reservedArea: 'Geschützter Bereich',
    contacts: 'Kontakt',
    location: 'Sardinien, Italien',
    copyright: '© 2026 InsulaCharter.',
  },

  // ============================================
  // HOMEPAGE
  // ============================================
  home: {
    tagline: 'Sardinien • Costa Smeralda',
    welcomeTitle: 'Das Meer erwartet Sie',
    welcomeSubtitle: 'Finden Sie das perfekte Boot für Ihr Abenteuer im kristallklaren Wasser der Costa Smeralda und den Buchten Sardiniens.',
    allPorts: 'Alle Häfen',
    passengersPlaceholder: 'Passagiere',
    passenger1: '1 Passagier',
    passengers2: '2 Passagiere',
    passengers3: '3 Passagiere',
    passengers4: '4 Passagiere',
    passengers5: '5 Passagiere',
    passengers6Plus: '6+ Passagiere',
    ourDestinations: 'Unsere Ziele',
    categoryCoastline: 'Küste',
    categoryIslands: 'Inseln',
    categoryBays: 'Buchten',
    categoryOpen: 'Offenes Meer',
    boatsInSardinia: 'Boote auf Sardinien',
    noBoatsTitle: 'Keine Boote verfügbar',
    noBoatsMessage: 'Versuchen Sie, die Suchfilter anzupassen',
    resetSearch: 'Suche zurücksetzen',
    boatFound: 'Boot gefunden',
    boatsFound: 'Boote gefunden',
    noResultsTitle: 'Keine Boote gefunden.',
    noResultsMessage: 'Versuchen Sie, die Suchkriterien anzupassen',
    showAllBoats: 'Alle Boote anzeigen',
    verifiedFleet: 'Zertifizierte und geprüfte Flotte',
    insurance: 'Versicherung',
    startDate: 'Abfahrtsdatum',
    endDate: 'Rückkehrdatum',
    noLicense: 'Ohne Bootsführerschein',
    // Hero
    premiumSelection: 'INSULA CHARTER PREMIUM SELECTION',
    heroDescription: 'Entdecken Sie die geheimsten Buchten Sardiniens mit unserer Premium-Flotte. Luxus trifft Freiheit.',
    // Benefits bar
    benefitFlexibility: 'Totale Flexibilität',
    benefitInstant: 'Sofortige Vermietung',
    benefitCertified: 'Zertifizierte Charters',
    // Catalog
    searchResults: 'Suchergebnisse',
    catalogTitle: 'Bootskatalog',
    searchResultsSubtitle: 'Wir haben {count} Boote für Ihre Kriterien gefunden.',
    catalogSubtitle: 'Entdecken Sie die exklusivsten Boote, ausgewählt für Sie.',
    resetFilters: 'Alle Filter zurücksetzen',
    noResults: 'Ups! Keine Boote für diese Kriterien verfügbar.',
    noResultsHint: 'Versuchen Sie, die Filter anzupassen oder die Suche zu erweitern.',
    resetFiltersBtn: 'Filter zurücksetzen',
    loadingBoats: 'Boote laden...',
    loadingMap: 'Karte laden...',
    // Destinations section
    exclusiveDestinations: 'Die exklusivsten Reiseziele',
    exclusiveDestinationsDesc: 'Von der Costa Smeralda zu den wilden Buchten der Ogliastra. Segeln Sie ins Paradies.',
    exploreMap: 'Karte erkunden',
  },

  // ============================================
  // NAVBAR (extended)
  // ============================================
  navbarExt: {
    home: 'Home',
    fleet: 'Flotte',
    excursions: 'Ausflüge',
    destinations: 'Ziele',
    blog: 'Blog',
    vendorPanel: 'Vermieter-Panel',
    vendorRole: 'Vermieter',
    lightTheme: 'Helles Design',
    darkTheme: 'Dunkles Design',
    navigation: 'Navigation',
    administration: 'Verwaltung',
    account: 'Konto',
    settings: 'Einstellungen',
    services: 'Dienstleistungen',
  },

  // ============================================
  // FOOTER (extended)
  // ============================================
  footerExt: {
    home: 'Home',
    destinations: 'Ziele',
    support: 'Hilfe',
    helpCenter: 'Hilfezentrum',
    termsConditions: 'AGB',
    cookiePrivacy: 'Cookies & Datenschutz',
    kaskoInsurance: 'Kaskoversicherung',
    securePayments: 'Sichere Zahlungen',
  },

  // ============================================
  // SEARCH SECTION
  // ============================================
  searchSection: {
    city: 'Stadt',
    allCities: 'Alle',
    allCitiesLong: 'Alle Städte',
    noCities: 'Keine Städte verfügbar',
    dates: 'Daten',
    dateStart: 'Beginn',
    dateEnd: 'Ende',
    times: 'Zeiten',
    pickup: 'Abholung',
    dropoff: 'Rückgabe',
    guests: 'Gäste',
    passengers: 'Passagiere',
    license: 'Führerschein',
    licenseAll: 'Alle',
    licenseNo: 'Nein',
    search: 'Suchen',
  },

  // ============================================
  // CATALOG TOOLBAR & FILTERS
  // ============================================
  catalog: {
    // Toolbar
    filters: 'Filter',
    searchPlaceholder: 'Boot, Hafen, Beschreibung suchen...',
    sortPriceAsc: 'Preis: aufsteigend',
    sortPriceDesc: 'Preis: absteigend',
    sortRating: 'Bewertung',
    sortReviews: 'Meistbewertet',
    sortNewest: 'Neueste',
    sortName: 'Name A-Z',
    sortDefault: 'Sortieren',
    viewGrid: 'Rasteransicht',
    viewList: 'Listenansicht',
    viewMap: 'Kartenansicht',
    boatFound: 'Boot gefunden',
    boatsFound: 'Boote gefunden',
    // Filters
    boatType: 'Bootstyp',
    dailyPrice: 'Tagespreis',
    priceRange: 'Verfügbarer Bereich',
    passengerCapacity: 'Passagierkapazität',
    departureCity: 'Abfahrtsstadt',
    allCities: 'Alle Städte',
    options: 'Optionen',
    noLicense: 'Ohne Bootsführerschein',
    skipperAvailable: 'Skipper verfügbar',
    resetFilters: 'Filter zurücksetzen',
    showResults: 'Ergebnisse anzeigen',
    // Pagination
    showing: 'Anzeige',
    of: 'von',
    results: 'Ergebnisse',
    prevPage: 'Vorherige Seite',
    nextPage: 'Nächste Seite',
    pageOf: 'Seite {current} von {total}',
  },

  // ============================================
  // BOAT CARD (extended)
  // ============================================
  boatCardExt: {
    premiere: 'Insula Première',
    licenseRequired: 'Führerschein erforderlich',
    noLicense: 'Ohne Führerschein',
    unavailable: 'Nicht verfügbar',
    startingFrom: 'Ab',
    from: 'ab',
    seasonalRate: 'Saisontarif',
    perDay: '/Tag',
    perHalfDay: '/halber Tag',
    perWeek: '/Woche',
    perMonth: '/Monat',
    shortStaySurcharge: 'Kurzaufenthalt-Zuschlag',
    length: 'Länge',
    passengers: 'Passagiere',
    cabins: 'Kabinen',
    bathrooms: 'Bäder',
    engine: 'Motor',
    skipperIncluded: 'Skipper inklusive',
    skipperAvailable: 'Skipper verfügbar',
    viewAlternatives: 'Alternativen ansehen',
    exploreDetails: 'Details erkunden',
    alternatives: 'Alternativen',
    details: 'Details',
    license: 'Führerschein',
    noLicenseShort: 'Ohne Führerschein',
    people: 'Personen',
    forDays: 'für {days} Tage',
    premium: 'Premium',
  },

  // ============================================
  // DATE RANGE PICKER
  // ============================================
  datePicker: {
    title: 'Mietdaten auswählen',
    clearSelection: 'Auswahl löschen',
    confirmDates: 'Daten bestätigen',
    boarding: 'Abholung',
    disembark: 'Rückgabe',
    day: 'Tag',
    days: 'Tage',
    selectBoarding: 'Abholdatum auswählen',
    selectDisembark: 'Rückgabedatum auswählen (gleiches Datum für Tagesmiete klicken)',
    available: 'Verfügbar',
    notAvailable: 'Nicht verfügbar',
    halfDay: 'Halber Tag',
    morningFree: 'Vormittag frei',
    morningBooked: 'Vormittag gebucht',
    afternoonFree: 'Nachmittag frei',
    afternoonBooked: 'Nachmittag gebucht',
    weekdayMon: 'Mo',
    weekdayTue: 'Di',
    weekdayWed: 'Mi',
    weekdayThu: 'Do',
    weekdayFri: 'Fr',
    weekdaySat: 'Sa',
    weekdaySun: 'So',
    weekdayFullMon: 'Montag',
    weekdayFullTue: 'Dienstag',
    weekdayFullWed: 'Mittwoch',
    weekdayFullThu: 'Donnerstag',
    weekdayFullFri: 'Freitag',
    weekdayFullSat: 'Samstag',
    weekdayFullSun: 'Sonntag',
    monthJan: 'Januar',
    monthFeb: 'Februar',
    monthMar: 'März',
    monthApr: 'April',
    monthMay: 'Mai',
    monthJun: 'Juni',
    monthJul: 'Juli',
    monthAug: 'August',
    monthSep: 'September',
    monthOct: 'Oktober',
    monthNov: 'November',
    monthDec: 'Dezember',
  },

  // ============================================
  // BOAT TYPES
  // ============================================
  boatTypes: {
    yacht: 'Yacht',
    sailboat: 'Segelboot',
    motorboat: 'Motorboot',
    catamaran: 'Katamaran',
    dinghy: 'Schlauchboot',
    jetski: 'Jetski',
  },

  // ============================================
  // BOAT CARD
  // ============================================
  boatCard: {
    exclusive: 'Premium',
    pricePerDay: 'Tagespreis',
    licenseRequired: 'Führerschein erforderlich',
    noLicenseRequired: 'Ohne Führerschein',
    capacity: 'Kapazität',
    length: 'Länge',
    power: 'Leistung',
  },

  // ============================================
  // BOAT (New fields)
  // ============================================
  boat: {
    linkCopied: 'Link in die Zwischenablage kopiert!',
    port: 'Abfahrtshafen',
    enginePower: 'Motorleistung',
    skipperAvailable: 'Skipper Verfügbar',
    skipperIncluded: 'Skipper Inklusive',
    hostessAvailable: 'Hostess Verfügbar',
    noLicense: 'Ohne Führerschein',
    licenseRequired: 'Führerschein Erforderlich',
    amenities: 'Bordausstattung',
    extras: 'Zusatzleistungen',
    perStay: 'pro Miete',
    perDay: 'pro Tag',
    perPerson: 'pro Person',
    perPersonPerDay: 'pro Person pro Tag',
    coverImage: 'Titelbild',
    selectCover: 'Als Titelbild auswählen',
    freeService: 'Kostenlos',
    externalServicesTitle: 'In diesem Hafen verfügbare Dienste',
    externalServicesEmpty: 'In diesem Hafen sind keine externen Dienste verfügbar.',
    externalServicesLoading: 'Dienste werden geladen...',
    externalServicesPlaceholder: 'Dieses Boot bietet zusätzliche Dienste',
    externalServicesContactUs: 'Kontaktieren Sie uns für weitere Informationen zu den verfügbaren Diensten.',
    availableServices: 'Für dieses Boot ausgewählte Dienste',
    fromPrice: 'ab €{price}',
    nProvidersAvailable: '{count} Anbieter verfügbar',
    anonymousProvider: 'Anbieter',
    externalServiceCategoryMobility: 'Verleih / Mobilität',
    externalServiceCategoryOther: 'Dienst',
    requestQuote: 'Angebot anfordern',
    requestQuoteTitle: 'Angebot anfordern',
    requestQuoteDate: 'Wunschdatum',
    requestQuoteGuests: 'Anzahl Personen',
    requestQuoteNotes: 'Hinweise (optional)',
    requestQuoteName: 'Ihr Name',
    requestQuoteEmail: 'E-Mail',
    requestQuotePhone: 'Telefon',
    requestQuoteSubmit: 'Anfrage senden',
    requestQuoteSuccess: 'Anfrage gesendet. Der Anbieter wird sich in Kürze melden.',
    requestQuoteAuthHint: 'Hinterlassen Sie Ihre Kontaktdaten, damit der Anbieter antworten kann',
  },

  // ============================================
  // REVIEWS (Bewertungen)
  // ============================================
  reviews: {
    title: 'Bewertungsverwaltung',
    newReview: 'Neue Bewertung',
    editReview: 'Bewertung bearbeiten',
    noReviews: 'Keine Bewertungen',
    addFirst: 'Fügen Sie die erste Bewertung für Ihre Boote hinzu',
    authorName: 'Name des Autors',
    rating: 'Bewertung',
    comment: 'Kommentar',
    reviewDate: 'Bewertungsdatum',
    adminResponse: 'Admin-Antwort',
    isVisible: 'Bewertung öffentlich sichtbar',
    hidden: 'Ausgeblendet',
    stars: 'Sterne',
    star: 'Stern',
    averageRating: 'Durchschnitt',
    totalReviews: 'Bewertungen',
    selectBoat: 'Boot auswählen',
    deleteConfirm: 'Möchten Sie diese Bewertung löschen?',
    created: 'Bewertung erfolgreich erstellt',
    updated: 'Bewertung erfolgreich aktualisiert',
    deleted: 'Bewertung erfolgreich gelöscht',
    showReview: 'Anzeigen',
    hideReview: 'Ausblenden',
  },

  // ============================================
  // BOAT DETAIL
  // ============================================
  boatDetail: {
    backButton: 'Flotte entdecken',
    notFound: 'Boot nicht gefunden.',
    loginRequired: 'Melden Sie sich an, um zu buchen.',
    selectDates: 'Wählen Sie die Daten aus der Suche.',
    characteristics: 'Eigenschaften',
    description: 'Beschreibung',
    tagSkipper: 'Skipper Verfügbar',
    tagInsured: 'Versicherung Inklusive',
    tagSupport: 'Support 24/7',
    whereIsIt: 'Abfahrtshafen',
    locationDescription: 'Gelegen im Hafen von {location}, einem der exklusivsten Häfen Sardiniens.',
    excellentPosition: 'Strategische Lage',
    homePort: 'Heimathafen',
    rate: 'Tarif',
    rental: 'Miete',
    passengersLabel: 'Passagiere',
    extrasOptional: 'Zusatzleistungen (Optional)',
    fuelPolicy: 'Kraftstoff',
    extrasTotal: 'Zusatzleistungen',
    bookNow: 'JETZT BUCHEN',
    processing: 'IN BEARBEITUNG...',
    protectionBadge: 'InsulaCharter Schutzgarantie',
    paymentMethod: 'Zahlungsmethode',
    selectPaymentMethod: 'Zahlungsmethode auswählen',
    noPaymentMethods: 'Keine gespeicherten Zahlungsmethoden',
    addPaymentMethod: 'Zahlungsmethode hinzufügen',
    cashDescription: 'Barzahlung bei Abholung',
    guaranteeRequired: 'Kaution erforderlich',
    guaranteeAmount: 'Kautionsbetrag',
    selectGuaranteeCard: 'Karte für die Kaution auswählen',
    cashNoCard: 'Barzahlung (Admin-Bestätigung erforderlich)',
    cashNoCardDescription: 'Ohne Garantiekarte erfordert die Buchung eine manuelle Bestätigung',
    specifications: 'Technische Daten',
    length: 'Länge',
    beam: 'Breite',
    engine: 'Motor',
    fuelCapacity: 'Tankinhalt',
    maxSpeed: 'Höchstgeschwindigkeit',
  },

  // ============================================
  // DASHBOARD (GUEST)
  // ============================================
  dashboard: {
    title: 'Persönlicher Bereich',
    greeting: 'Willkommen zurück, {name}. Verwalten Sie Ihre Bootsvermietungen auf Sardinien.',
    profileSailor: 'Seglerprofil',
    menuUpcomingTrips: 'Kommende Mieten',
    menuPaymentMethods: 'Zahlungsmethoden',
    menuSaved: 'Gespeichert',
    menuPersonalInfo: 'Persönliche Daten',
    confirmedBookings: 'Bestätigte Buchungen',
    pickupDate: 'Abholung',
    returnDate: 'Rückgabe',
    receipt: 'Quittung',
    cancelBooking: 'Stornieren',
    noTripsTitle: 'Keine bestätigten Mieten',
    noTripsMessage: 'Das Meer erwartet Sie. Beginnen Sie mit der Planung Ihres nächsten Abenteuers!',
    exploreBoats: 'Flotte entdecken',
    historyAndCancelled: 'Verlauf und Stornierungen',
    statusCancelled: 'Storniert',
    myBookings: 'Meine Buchungen',
    upcomingTrips: 'Kommende Mieten',
    paymentMethods: 'Zahlungsmethoden',
    saved: 'Gespeichert',
    personalInfo: 'Persönliche Daten',
    noBookings: 'Keine Miete gebucht',
    noBookingsDesc: 'Das Meer erwartet Sie. Beginnen Sie mit der Planung Ihres nächsten Abenteuers!',
    savedComingSoon: 'Gespeicherte Boote',
    savedDescription: 'Funktion in Kürze verfügbar. Bald können Sie Ihre Lieblingsboote speichern.',
  },

  // ============================================
  // ADMIN DASHBOARD
  // ============================================
  admin: {
    title: 'Admin-Dashboard',
    subtitle: 'Zentrale Verwaltung InsulaCharter Sardinien.',
    addBoat: 'Boot hinzufügen',
    bookingsTitle: 'Buchungen',
    bookingsSubtitle: 'Buchungen verwalten',

    // Boat port/marina (for external services matching)
    boatPortMarina: 'Hafen/Marina',
    boatPortMarinaHint: 'Die für Kunden sichtbaren externen Dienste hängen vom hier gewählten Hafen ab.',
    boatPortMarinaNone: '— Kein Hafen —',
    boatPortMarinaLoading: 'Häfen werden geladen...',

    // Role management
    changeRole: 'Rolle ändern',
    changeRoleConfirm: 'Sind Sie sicher, dass Sie die Rolle dieses Benutzers ändern möchten?',
    changeRoleSuccess: 'Rolle erfolgreich aktualisiert',
    changeRoleAdminWarning: 'Dies gewährt vollen Admin-Zugriff auf die Plattform.',
    changeRoleWarningBoats: 'Dieser Benutzer hat {count} aktive Boote. Die Rollenänderung deaktiviert seine Angebote.',
    changeRoleForce: 'Trotzdem fortfahren',
    cannotChangeOwnRole: 'Sie können Ihre eigene Rolle nicht ändern',
    cannotDemoteLastAdmin: 'Der letzte Plattform-Administrator kann nicht entfernt werden',
    roleAlreadyAssigned: 'Benutzer hat bereits diese Rolle',
    confirmAdminRequired: 'Ausdrückliche Bestätigung erforderlich für Admin-Beförderung',
    invalidRole: 'Ungültige Rolle',
    role_hub_internal_only: 'Dieses Konto (ADMIN oder Dienstleister) wird nur über den Hub verwaltet, nicht hier.',
    newRole: 'Neue Rolle',
    vendorStatusOption: 'Anfänglicher Vendor-Status',

    // Service Provider invitations
    inviteServiceProvider: 'Anbieter einladen',
    inviteEmailLabel: 'Anbieter-E-Mail',
    inviteNameLabel: 'Name (optional)',
    inviteDesc: 'Eine E-Mail mit einem 48 Stunden gültigen Registrierungslink wird gesendet.',
    inviteSend: 'Einladung senden',
    inviteSent: 'Einladung erfolgreich gesendet',
    inviteAcceptTitle: 'Registrierung abschließen',
    inviteAcceptDesc: 'Sie wurden eingeladen, InsulaCharter als Dienstleister beizutreten.',

    // Preview links
    previewVendor: 'Vendor-Vorschau',
    previewServiceProvider: 'Anbieter-Vorschau',

    // Tabs
    tabDashboard: 'Übersicht',
    tabCalendar: 'Kalender',
    tabMyBoats: 'Flotte',
    tabReviews: 'Bewertungen',
    tabBookings: 'Bootsbuchungen',
    tabClientBookings: 'Kundenbuchungen',
    tabServices: 'Bordservices',
    calendarTitle: 'Buchungskalender',
    calendarSubtitle: 'Alle Buchungen Ihrer Flotte anzeigen',
    fleetOverview: 'Flottenübersicht',

    // Stats
    statsOverview: 'Gesamtübersicht',
    statsTotalRevenue: 'Gesamteinnahmen',
    statsConfirmed: 'bestätigt',
    statsUniqueClients: 'Einzelkunden',
    statsRegisteredClients: 'registrierte Kunden',
    statsActiveBoats: 'Aktive Boote',
    statsInFleet: 'in der Flotte',
    statsPending: 'Ausstehend',
    statsToConfirm: 'zu bestätigen',

    // Economic averages
    economicAverages: 'Wirtschaftliche Durchschnittswerte',
    avgBookingValue: 'Durchschnittlicher Buchungswert',
    avgPricePerDay: 'Durchschnittlicher Tagespreis',
    confirmationRate: 'Bestätigungsrate',

    // Booking trends
    bookingTrends: 'Buchungstrends',
    last30Days: 'Letzte 30 Tage',
    confirmedBookings: 'bestätigte Buchungen',
    bookingStatus: 'Buchungsstatus',
    statusConfirmed: 'Bestätigt',
    statusPending: 'Ausstehend',
    statusCancelled: 'Storniert',

    // Pricing tabs
    tabPricingRules: 'Preisregeln',
    tabPricingCalendar: 'Preiskalender',
    tabTariffe: 'Tarife',
    tabTariffeReadonly: 'Tarife (nur lesen)',
    tabPricing: 'Preise & Aktionen',

    // Pricing management (3-step flow)
    pricingTitle: 'Preise',
    pricingSubtitle: 'Eigentümer, Boote und detaillierte Preise durchsuchen',
    pricingBreadcrumbOwners: 'Alle Eigentümer',
    pricingSelectOwner: 'Eigentümer auswählen',
    pricingLoadingOwners: 'Eigentümer werden geladen...',
    pricingNoOwnersFound: 'Keine Eigentümer gefunden',
    pricingFilterAll: 'Alle',
    pricingSearchOwner: 'Name oder E-Mail suchen...',
    pricingColOwner: 'Eigentümer',
    pricingColEmail: 'E-Mail',
    pricingColRole: 'Rolle',
    pricingColBoats: 'Boote',
    pricingBoatsOf: 'Boote von',
    pricingBoatSingular: 'Boot',
    pricingBoatPlural: 'Boote',
    pricingNoBoats: 'Dieser Eigentümer hat keine registrierten Boote',
    pricingColBoatName: 'Boot',
    pricingColType: 'Typ',
    pricingColLength: 'Länge',
    pricingColPriceDay: '\u20AC/Tag',
    pricingColPriceHalf: '\u20AC/halbtags',
    pricingColStatus: 'Status',
    pricingBackToOwners: 'Zurück zu den Eigentümern',
    pricingBackToBoats: 'Zurück zu den Booten von',
    pricingLoadingPricing: 'Preise werden geladen...',
    pricingSearchBoats: 'Boot suchen...',
    pricingAllTypes: 'Alle Typen',
    pricingAllStatuses: 'Alle Status',

    tabPricePolicies: 'Preisrichtlinien',
    tabCoupons: 'Gutscheine & Aktionen',
    tabInviteCodes: 'Einladungscodes',
    tabAmbassadors: 'Botschafter',
    tabAmbassadorTiers: 'Botschafter-Stufen',
    tabServicePlatformFee: 'Dienstgebühren',
    tabExternalServicesPayout: 'Dienstauszahlungen',
    usersRetrievalError: 'Fehler beim Abrufen der Benutzer',

    // Fleet management
    fleet: {
      title: 'Flottenverwaltung',
      addBoat: 'Boot hinzufügen',
      filterAll: 'Alle',
      filterCompany: 'Unternehmen',
      filterVendor: 'Privat',
      filterPlatform: 'Plattform',
      searchPlaceholder: 'Boot, Eigentümer, Hafen suchen...',
      allTypes: 'Alle Typen',
      allPorts: 'Alle Häfen',
      clearFilters: 'Filter löschen',
      expandAll: 'Alle aufklappen',
      collapseAll: 'Alle zuklappen',
      boat: 'Boot',
      boats: 'Boote',
      owner: 'Eigentümer',
      owners: 'Eigentümer',
      company: 'Unternehmen',
      vendor: 'Privater Anbieter',
      platform: 'Plattform',
      colBoat: 'Boot',
      colType: 'Typ',
      colPort: 'Hafen',
      colCapacity: 'Kapazität',
      colPrice: 'Tarif/Tag',
      colActions: 'Aktionen',
      rentalDay: 'Tag',
      rentalWeek: 'Woche',
      rentalMonth: 'Monat',
      viewDetails: 'Details anzeigen',
      edit: 'Bearbeiten',
      delete: 'Löschen',
      empty: 'Keine Boote in der Flotte',
      emptyHint: 'Fügen Sie Ihr erstes Boot hinzu',
      noResults: 'Keine Boote gefunden',
      noResultsHint: 'Versuchen Sie die Suchfilter anzupassen',
    },

    // Promotions tab
    tabPromotions: 'Aktionen',
    tabSuspensions: 'Sperrungen',
    tabMobility: 'Externe Dienste',
    tabMobilityServices: 'Servicekatalog',
    tabExtraCategories: 'Dienstkategorien',
    tabExternalServices: 'Externe Dienste (API)',
    apiCatalogTitle: 'Servicekatalog von InsulaServices',
    apiCatalogDesc: 'Verfügbare Dienste von insulaservices.it für Boote. Klicken Sie auf "Sync" zum Aktualisieren.',
    apiCatalogSync: 'Synchronisieren',
    apiCatalogSyncing: 'Synchronisierung...',
    apiCatalogEmpty: 'Keine Dienste verfügbar. Versuchen Sie zu synchronisieren.',
    apiCatalogError: 'Fehler bei der Kontaktaufnahme mit insulaservices.it',
    apiCatalogQuote: 'Auf Anfrage',
    apiCatalogPerPerson: '/Person',
    extraCategoriesTitle: 'Dienstkategorien',
    extraCategoriesDesc: 'Erstellen und verwalten Sie Servicekategorien. Als "extern" markierte Kategorien sind für Kunden sichtbar und von Service Providern auswählbar.',
    extraCategoriesNew: 'Neue Kategorie',
    extraCategoriesEdit: 'Kategorie bearbeiten',
    extraCategoriesEmpty: 'Keine Kategorien konfiguriert',
    extraCategoriesSlug: 'Slug (eindeutige ID)',
    extraCategoriesLabel: 'Bezeichnung',
    extraCategoriesDescription: 'Beschreibung',
    extraCategoriesIcon: 'Symbol',
    extraCategoriesIconHint: 'Lucide-Symbolname (z.B. Bike, Camera, Utensils, Anchor)',
    extraCategoriesColor: 'Badge-Farbe',
    extraCategoriesSortOrder: 'Reihenfolge',
    extraCategoriesVisibility: 'Sichtbarkeit',
    extraCategoriesExternal: 'Extern (für Kunden sichtbar)',
    extraCategoriesExternalShort: 'extern',
    extraCategoriesInternal: 'Intern (nur Admin)',
    extraCategoriesInternalShort: 'intern',
    extraCategoriesProtected: 'Geschützte Kategorie — kann nicht gelöscht werden',
    extraCategoriesProtectedHint: 'Geschützte Kategorien können Slug und Sichtbarkeit nicht ändern',
    extraCategoriesUsage: 'in Verwendung',
    extraCategoriesMoveUp: 'Nach oben',
    extraCategoriesMoveDown: 'Nach unten',
    extraCategoriesValidation: 'Slug und Bezeichnung sind erforderlich',
    extraCategoriesCreated: 'Kategorie erstellt',
    extraCategoriesUpdated: 'Kategorie aktualisiert',
    extraCategoriesDeleted: 'Kategorie gelöscht',
    extraCategoriesConfirmDelete: 'Diese Kategorie endgültig löschen?',
    mobilityServices: 'Mobilitätsdienste',
    mobilityServicesDesc: 'Verwalten Sie Fahrräder, Roller, E-Scooter und Transfers für Gäste',
    noMobilityServices: 'Keine Mobilitätsdienste konfiguriert',
    tabTransferOverview: 'Transfers',
    transferOverview: 'Transfer-Übersicht',
    unassigned: 'Nicht zugewiesen',
    reassign: 'Neu zuweisen',
    tabServiceProviders: 'Dienstleister',
    tabServiceRequests: 'Serviceanfragen',
    serviceProviders: 'Dienstleister',
    serviceProvidersDesc: 'Verwalten Sie Anbieter, die Mobilitäts- und Transferdienste erbringen',
    addProvider: 'Anbieter hinzufügen',
    noProviders: 'Keine Anbieter registriert',
    selectUser: 'Benutzer auswählen',
    selectService: 'Dienst auswählen',
    maxCapacity: 'Maximale Kapazität',
    serviceRequests: 'Serviceanfragen',
    serviceRequestsDesc: 'Übersicht aller Serviceanfragen aus Buchungen',
    noServiceRequests: 'Keine Serviceanfragen',
    // Mobility sub-tab extras
    tabMobilityOverview: 'Übersicht',
    mobilityOverview: 'Mobilität Übersicht',
    mobilityOverviewDesc: 'Globale Statistiken zu Anbietern und Serviceanfragen',
    mobilityProvidersTotal: 'Anbieter gesamt',
    mobilityProvidersActive: 'Aktive Anbieter',
    mobilityProvidersInactive: 'Inaktive Anbieter',
    mobilityRequestsTotal: 'Anfragen gesamt',
    mobilityTopProviders: 'Top 5 Anbieter (abgeschlossene Anfragen)',
    mobilityNoTopProviders: 'Noch kein Anbieter mit abgeschlossenen Anfragen',
    mobilityRefresh: 'Aktualisieren',
    mobilityLoadError: 'Fehler beim Laden der Mobilitätsdaten',
    mobilityOpenSpDashboard: 'SP-Dashboard öffnen',
    mobilityPendingBadge: '{count} ausstehend',
    mobilityStatusActive: 'Aktiv',
    mobilityStatusInactive: 'Inaktiv',
    mobilityEditName: 'Name',
    mobilityEditPrice: 'Preis (€)',
    mobilityEditPriceType: 'Preistyp',
    mobilityEditDescription: 'Beschreibung',
    mobilityEnable: 'Aktivieren',
    mobilityDisable: 'Deaktivieren',
    mobilityLabelCapacity: 'Kap.',
    mobilityLabelProvider: 'Anbieter',
    mobilityLabelQuantity: 'Menge',
    mobilityToggleError: 'Servicestatus kann nicht aktualisiert werden',
    mobilitySaveError: 'Änderungen können nicht gespeichert werden',
    mobilityLoadProvidersError: 'Anbieter können nicht geladen werden',
    mobilityLoadRequestsError: 'Anfragen können nicht geladen werden',
    // External services moderation
    externalServicesTitle: 'Externe Dienstleistungen',
    externalServicesDesc: 'Moderieren und verwalten Sie die von Service Providern erstellten Dienstleistungen',
    externalServicesPending: 'Warten auf Freigabe',
    externalServicesApprove: 'Genehmigen',
    externalServicesReject: 'Ablehnen',
    externalServicesRejectReason: 'Ablehnungsgrund',
    externalServicesNotes: 'Notizen (für SP sichtbar)',
    externalServiceCreator: 'Erstellt von',
    externalServiceCreatorAdmin: 'Admin (Plattform)',
    externalServicePorts: 'Betriebshäfen',
    externalServiceNoPort: 'Kein Hafen verknüpft',
    // Price type labels
    priceType_per_stay: 'Pro Aufenthalt',
    priceType_per_day: 'Pro Tag',
    priceType_per_night: 'Pro Nacht',
    priceType_per_person: 'Pro Person',
    priceType_per_person_per_day: 'Pro Person/Tag',
    priceType_per_person_per_night: 'Pro Person/Nacht',
    confirmDelete: 'Sind Sie sicher, dass Sie löschen möchten?',
    tabPoi: 'Sehenswürdigkeiten',
    tabPorts: 'Häfen',
    promoTitle: 'Titel',
    promoSubtitle: 'Untertitel',
    promoDescription: 'Beschreibung',
    promoImage: 'Bild',
    promoCtaText: 'CTA-Text',
    promoCtaLink: 'CTA-Link',
    promoBadge: 'Badge',
    promoStartDate: 'Startdatum',
    promoEndDate: 'Enddatum',
    promoActive: 'Aktiv',
    promoOrder: 'Reihenfolge',
    promoNew: 'Neue Aktion',
    promoEdit: 'Aktion bearbeiten',
    promoDelete: 'Aktion löschen',
    promoDeleteConfirm: 'Sind Sie sicher, dass Sie diese Aktion löschen möchten?',
    promoCreated: 'Aktion erfolgreich erstellt',
    promoUpdated: 'Aktion erfolgreich aktualisiert',
    promoDeleted: 'Aktion erfolgreich gelöscht',
    promoNoResults: 'Keine Aktionen gefunden',
    promoAlwaysVisible: 'Immer sichtbar',
    promoSave: 'Speichern',
    promoCancel: 'Abbrechen',
    promoUploadImage: 'Bild hochladen',
    promoOrImageUrl: 'oder Bild-URL eingeben',
    promoToggleActive: 'Aktivieren/Deaktivieren',
    promoReorderHint: 'Pfeile zum Umordnen verwenden',
    promoMoveUp: 'Nach oben',
    promoMoveDown: 'Nach unten',

    // Trends tab
    tabTrends: 'Trends',
    trendsTotalRevenue: 'Einnahmen Zeitraum',
    trendsMonthlyAvg: 'Monatsdurchschnitt',
    trendsPerMonth: 'pro Monat',
    trendsTrend: 'Trend',
    trendsVsPrev: 'vs. vorheriger Zeitraum',
    trendsBookings: 'Buchungen',
    trendsRevenue: 'Einnahmen',

    // Recent bookings table
    recentBookings: 'Letzte Buchungen',
    tableDate: 'Datum',
    tableBoat: 'Boot',
    tablePickupReturn: 'Abholung/Rückgabe',
    tableValue: 'Wert',
    tableStatus: 'Status',
    noBookingsYet: 'Noch keine Buchungen',
    clientProfile: 'Kundenprofil',
    bookingHistory: 'Buchungsverlauf',
    totalSpent: 'Gesamtausgaben',
    cancellationReason: 'Stornierungsgrund',
    confirmBooking: 'Buchung bestätigen',
    cancelBooking: 'Buchung stornieren',
    completeBooking: 'Buchung abschließen',
    refundDeposit: 'Anzahlung erstatten',
    depositRefunded: 'Anzahlung erstattet',

    // Boats table
    tableVessel: 'Boot',
    tablePort: 'Hafen',
    tableRate: 'Tarif',
    tableActions: 'Aktionen',

    // Bookings table
    tableClients: 'Kunden',
    tablePeriod: 'Zeitraum',
    tableTotal: 'Gesamt',
    tablePaymentStatus: 'Zahlung',
    vendorSuspended: 'Anbieter gesperrt',
    vendorBookingsSuspended: 'Buchungen gesperrt',
    boatName: 'Boot',
    email: 'E-Mail',
    embarkation: 'Einschiffung',
    disembarkation: 'Ausschiffung',
    deposit: 'Anzahlung',

    // Booking list/calendar view
    allStatuses: 'Alle',
    allPaymentStatuses: 'Alle Zahlungen',
    paymentPending: 'Zu bezahlen',
    paymentPaid: 'Bezahlt',
    paymentPartial: 'Teilweise',
    paymentRefunded: 'Erstattet',
    calendarView: 'Kalender',
    listView: 'Liste',
    searchGuest: 'Kunde suchen...',
    cancelWithReason: 'Mit Begründung stornieren',
    cancelConfirmMessage: 'Sind Sie sicher, dass Sie diese Buchung stornieren möchten?',
    cancelReasonPlaceholder: 'Grund der Stornierung (optional)',

    // Summary cards
    pendingBookings: 'Ausstehend',
    confirmedRevenue: 'Bestätigte Einnahmen',

    // Booking detail modal
    bookingDetail: 'Buchungsdetails',
    guestInfo: 'Kundeninformationen',
    firstName: 'Vorname',
    boatInfo: 'Bootsinformationen',
    port: 'Hafen',
    rentalDetails: 'Mietdetails',
    experienceDetails: 'Details zum Erlebnis',
    priceSummary: 'Preisübersicht',
    basePrice: 'Grundpreis',
    insuranceFee: 'Versicherung',
    extras: 'Extras',
    specialRequests: 'Sonderwünsche',
    downloadReceipt: 'Quittung',
    noBookingsFound: 'Keine Buchungen gefunden',

    // Reversible bookings
    reversibleBookings: 'Widerrufbare Buchungen',
    reversibleBookingsSubtitle: 'Sie können den vorherigen Status wiederherstellen',
    reverse: 'Wiederherstellen',
    undo: 'Rückgängig',

    // Calendar overview
    boatsOverview: 'Bootsübersicht',
    confirmedShort: 'bestät.',
    pendingShort: 'aussteh.',
    blockedShort: 'gesperrt',

    // Services section
    includedServices: 'Bordausstattung',
    includedServicesSubtitle: 'Verwalten Sie die in den Booten enthaltene Ausstattung',
    addEquipment: 'Ausstattung hinzufügen',
    extraServices: 'Zusatzleistungen (Kostenpflichtig)',
    extraServicesSubtitle: 'Verwalten Sie die Zusatzleistungen, die zu den Mieten hinzugefügt werden können. Der Preis wird für jedes Boot festgelegt.',
    addExtraService: 'Zusatzleistung hinzufügen',

    // Extras approval (admin)
    extraFilterAll: 'Alle',
    extraFilterPlatform: 'Plattform',
    extraFilterVendors: 'Anbieter',
    extraFilterPending: 'Ausstehend',
    extraCreatorPlatform: 'Plattform',
    extraCreatorLabel: 'Erstellt von',
    extraApprove: 'Genehmigen',
    extraReject: 'Ablehnen',
    extraRejectNotes: 'Ablehnungsgrund',
    extraRejectNotesPlaceholder: 'Erklären Sie den Ablehnungsgrund...',
    extraPendingCount: 'ausstehende Extras',
    extraApproved: 'Extra genehmigt',
    extraRejected: 'Extra abgelehnt',
    extraApproveError: 'Fehler bei der Genehmigung',
    extraRejectError: 'Fehler bei der Ablehnung',
    extraPromote: 'Global machen',
    extraPromoted: 'Extra zum globalen Plattformdienst befördert',
    extraPromoteError: 'Fehler bei der Beförderung',
    extraPromoteConfirm: 'Dieses Extra für alle Boote der Plattform verfügbar machen? Der Anbieter verliert die exklusive Eigentümerschaft.',

    // Audit History
    auditTitle: 'Vorgangshistorie',
    auditSubtitle: 'Vollständiger Verlauf der Operationen an Zusatzleistungen für Rückverfolgbarkeit und Streitfälle',
    auditTotalEntries: 'registrierte Vorgänge',
    auditNoEntries: 'Keine Vorgänge registriert',
    auditDetails: 'Vorgangsdetails',
    auditPage: 'Seite',

    tableService: 'Service',
    tableDescription: 'Beschreibung',
    tableIcon: 'Symbol',

    // Boat modal
    modalNewBoat: 'Neues InsulaCharter Boot',
    modalEditBoat: 'InsulaCharter Boot bearbeiten',
    formBoatName: 'Bootsname',
    formBoatNamePlaceholder: 'z.B.: Azzurra',
    formPort: 'Heimathafen',
    formPortPlaceholder: 'z.B.: Porto Cervo',
    formPricePerDay: 'Tagespreis (€)',
    formInsuranceFee: 'Versicherung (€)',
    formDescription: 'Beschreibung',
    formDescriptionPlaceholder: 'Beschreiben Sie die Eigenschaften dieses Bootes...',

    // Photos section
    photosSection: 'Bootsfotos',
    photoCover: 'Titelbild',
    photoSetCover: 'Als Titelbild verwenden',
    addPhoto: 'Foto hinzufügen',
    addPhotoMaxReached: 'Foto hinzufügen (Maximum erreicht)',

    // Specifications
    specifications: 'Technische Daten',
    formLength: 'Länge (m)',
    formBeam: 'Breite (m)',
    formCapacity: 'Passagierkapazität',
    formEngine: 'Motorisierung',
    formLicenseRequired: 'Bootsführerschein erforderlich',

    // Services in boat
    onboardEquipment: 'Bordausstattung',
    extraServicesPaid: 'Zusatzleistungen (kostenpflichtig)',
    extraServicesCustomPrice: 'Legen Sie individuelle Preise für dieses Boot fest',

    // Buttons
    saveChanges: 'Änderungen speichern',
    createListing: 'Boot veröffentlichen',

    // Equipment modal
    modalNewEquipment: 'Neue Ausstattung',
    modalEditEquipment: 'Ausstattung bearbeiten',
    formServiceId: 'Service-ID',
    formServiceIdPlaceholder: 'z.B.: sonnensegel',
    formServiceIdHelper: 'Nur Kleinbuchstaben und Unterstriche verwenden',
    formServiceName: 'Servicename',
    formServiceNamePlaceholder: 'z.B.: Sonnensegel',
    formServiceDescriptionPlaceholder: 'Beschreiben Sie die Ausstattung...',
    formIconOptional: 'Symbol (optional)',
    iconDefault: 'Info (Standard)',
    iconAnchor: 'Anker',
    iconLifeBuoy: 'Rettungsring',
    iconCompass: 'Kompass',
    iconSun: 'Sonne',
    iconWaves: 'Wellen',
    iconWind: 'Wind',
    iconFuel: 'Kraftstoff',
    iconRadio: 'Funk',
    iconGps: 'GPS',

    // Extra modal
    modalNewExtra: 'Neue Zusatzleistung',
    modalEditExtra: 'Zusatzleistung bearbeiten',
    formExtraIdPlaceholder: 'z.B.: skipper_service',
    formExtraNamePlaceholder: 'z.B.: Professioneller Skipper',
    formExtraDescriptionPlaceholder: 'Beschreiben Sie die Zusatzleistung...',
    extraPriceInfo: 'Der Preis des Dienstes wird für jedes Boot individuell festgelegt.',

    // Multilingual translations
    translationsSection: 'Übersetzungen',
    translationsHelper: 'Geben Sie die Übersetzungen für jede unterstützte Sprache ein',
    translationsHelperAuto: 'Geben Sie den Text auf Italienisch ein und klicken Sie auf "Automatisch übersetzen", um die anderen Übersetzungen zu generieren.',
    autoTranslate: 'Automatisch übersetzen',
    translating: 'Übersetzen...',
    translationComplete: 'Übersetzung abgeschlossen!',
    translationFailed: 'Fehler bei der Übersetzung',
    enterItalianFirst: 'Geben Sie zuerst den italienischen Text ein',
    sourceLang: 'Quellsprache',
    labelIT: 'Name (Italienisch)',
    labelEN: 'Name (Englisch)',
    labelDE: 'Name (Deutsch)',
    descriptionIT: 'Beschreibung (Italienisch)',
    descriptionEN: 'Beschreibung (Englisch)',
    descriptionDE: 'Beschreibung (Deutsch)',
    langIT: 'Italienisch',
    langEN: 'Englisch',
    langDE: 'Deutsch',

    // Category options
    formCategory: 'Kategorie',
    categoryGeneral: 'Allgemeiner Service',
    categorySafety: 'Sicherheit',
    categoryComfort: 'Komfort',
    categoryNavigation: 'Navigation',
    categoryEntertainment: 'Unterhaltung',
    categorySpecial: 'Spezieller Service (grünes Abzeichen)',

    // Blocked Dates
    allBoats: 'Alle Boote',
    blockDates: 'Daten sperren',
    blockDatesTitle: 'Daten sperren',
    blockedPeriods: 'Gesperrte Zeiträume',
    blocked: 'gesperrt',
    unblock: 'Entsperren',
    blockingFor: 'Sperrung für',
    startDate: 'Startdatum',
    endDate: 'Enddatum',
    blockReason: 'Grund (optional)',
    blockReasonPlaceholder: 'z.B.: Wartung, Privatnutzung...',
    blockWarning: 'Gesperrte Daten sind für neue Mieten nicht verfügbar und werden den Benutzern als "nicht verfügbar" angezeigt.',
    confirmBlock: 'Daten sperren',
    selectBoatFirst: 'Wählen Sie zuerst ein Boot aus',
    selectDatesFirst: 'Wählen Sie die Daten aus',
    datesBlocked: 'Daten erfolgreich gesperrt',
    datesUnblocked: 'Daten entsperrt',
    confirmUnblock: 'Möchten Sie diese Daten entsperren?',
    tabSettings: 'Einstellungen',
    tabClients: 'Kunden',
    tabClientManagement: 'Kunden',

    // Clients section
    clientsTitle: 'Kundenverwaltung',
    searchClients: 'Nach Name oder E-Mail suchen...',
    searchBookings: 'Kunde, E-Mail suchen...',
    noClients: 'Keine registrierten Kunden',
    tableClient: 'Kunde',
    tableEmail: 'E-Mail',
    tableBookingsCount: 'Buchungen',
    tableTotalSpent: 'Gesamtausgaben',
    tableRegistered: 'Registriert am',
    registeredOn: 'Registriert am',
    totalBookings: 'Gesamt',
    viewClient: 'Kunde anzeigen',
    clientConfirmedBookings: 'Bestätigt',
    clientPendingBookings: 'Ausstehend',
    clientCancelledBookings: 'Storniert',
    emailVerified: 'E-Mail Verifiziert',
    emailNotVerified: 'E-Mail Nicht Verifiziert',

    // Admin User Management
    userManagement: 'Erweiterte Verwaltung',
    userManagementDesc: 'Administratoraktionen für diesen Benutzer',
    resetEmailVerification: 'E-Mail-Verifizierung zurücksetzen',
    resetEmailVerificationDesc: 'Setzt den E-Mail-Verifizierungsstatus zurück. Der Benutzer muss seine E-Mail erneut verifizieren.',
    resetEmailVerificationSuccess: 'E-Mail-Verifizierung erfolgreich zurückgesetzt',
    resetPassword: 'Passwort zurücksetzen',
    resetPasswordDesc: 'Sendet eine Passwort-Zurücksetzungs-E-Mail an den Benutzer.',
    resetPasswordSuccess: 'Passwort-Zurücksetzungs-E-Mail gesendet',
    resetPasswordEmailFailed: 'E-Mail konnte nicht gesendet werden. Token für manuelle Verwendung generiert.',
    emailNotConfigured: 'E-Mail nicht konfiguriert. Token für manuelle Verwendung generiert.',
    userNotFound: 'Benutzer nicht gefunden',
    confirmAction: 'Aktion bestätigen',
    confirmResetEmailVerification: 'Sind Sie sicher, dass Sie die E-Mail-Verifizierung für diesen Benutzer zurücksetzen möchten?',
    confirmResetPassword: 'Sind Sie sicher, dass Sie eine Passwort-Zurücksetzungs-E-Mail an diesen Benutzer senden möchten?',
    // Suspension
    suspendUser: 'Benutzer sperren',
    suspendUserDesc: 'Zugang zur Plattform sperren und neue Buchungen verhindern.',
    unsuspendUser: 'Benutzer reaktivieren',
    unsuspendUserDesc: 'Vollständigen Zugang zur Plattform wiederherstellen.',
    suspendUserSuccess: 'Benutzer erfolgreich gesperrt',
    unsuspendUserSuccess: 'Benutzer erfolgreich reaktiviert',
    confirmSuspendUser: 'Sind Sie sicher, dass Sie diesen Benutzer sperren möchten? Er kann nicht mehr auf die Plattform zugreifen.',
    confirmUnsuspendUser: 'Sind Sie sicher, dass Sie diesen Benutzer reaktivieren möchten?',
    suspensionReason: 'Sperrgrund',
    suspensionReasonPlaceholder: 'Z.B.: Verstoß gegen Nutzungsbedingungen, betrügerische Zahlungen...',
    suspended: 'Gesperrt',
    suspendedSince: 'Gesperrt seit',
    accountSuspended: 'Konto gesperrt',
    accountSuspendedDesc: 'Ihr Konto wurde gesperrt. Kontaktieren Sie den Support für weitere Informationen.',
    suspendCompanyDesc: 'Zugang zur Plattform sperren, neue Buchungen verhindern und Boote aus dem Katalog ausblenden.',

    // Monitoring / Logs
    tabMonitoring: 'Überwachung',
    tabLogs: 'Ereignisprotokolle',
    tabRawConsole: 'Rohkonsole',
    logs: {
      title: 'Systemprotokolle',
      description: 'Ereignis- und Aktivitätsprotokoll der Plattform',
      filterCategory: 'Kategorie',
      filterLevel: 'Stufe',
      filterFrom: 'Von',
      filterTo: 'Bis',
      filterSearch: 'In Nachricht suchen...',
      filterActor: 'Benutzer (ID)',
      reset: 'Zurücksetzen',
      exportCsv: 'CSV exportieren',
      columns: {
        timestamp: 'Datum',
        level: 'Stufe',
        category: 'Kategorie',
        action: 'Aktion',
        actor: 'Benutzer',
        target: 'Ziel',
        message: 'Nachricht',
        ip: 'IP',
        details: 'Details',
      },
      detailsTitle: 'Ereignisdetails',
      metadata: 'Metadaten',
      requestId: 'Request ID',
      empty: 'Keine Ereignisse',
      loading: 'Protokolle werden geladen...',
      page: 'Seite {{n}} von {{total}}',
      levels: {
        all: 'Alle',
        info: 'Info',
        warn: 'Warnung',
        error: 'Fehler',
      },
      categories: {
        all: 'Alle',
        auth: 'Authentifizierung',
        ambassador: 'Ambassador',
        booking: 'Buchungen',
        payment: 'Zahlungen',
        admin: 'Admin',
        system: 'System',
        http: 'HTTP',
      },
    },

    bookings: {
      actionCancel: 'Stornieren',
      actionHardDelete: 'Endgültig löschen',
      paymentMethod: 'Zahlungsmethode',
      amountPaid: 'Bezahlter Betrag',
      confirmCancel: 'Stornierung bestätigen',

      hardDeleteTitle: 'Endgültige Löschung',
      hardDeleteWarningTitle: 'ENDGÜLTIGE LÖSCHUNG — UNWIDERRUFLICH',
      hardDeleteWarning: 'Dieser Vorgang löscht die Buchung dauerhaft aus der Datenbank. Nur für Testdaten verwenden, niemals in Produktion.',
      hardDeleteConfirmType: 'Zur Bestätigung "{keyword}" eingeben',
      hardDeleteConfirm: 'Endgültig löschen',

      cancelRefundTitle: 'Buchung stornieren & erstatten',
      refundPreview: 'Erstattungsbetrag',
      refundPolicy: 'Angewandte Richtlinie',
      refundViaMollie: 'Automatisch über Mollie erstatten',
      refundViaMollieDesc: 'Mollie verarbeitet die Erstattung auf dieselbe Karte, die der Kunde verwendet hat.',
      refundManualWarningTitle: 'Manuelle Erstattung erforderlich',
      refundManualWarning: 'Zahlung über {gateway}: nach der Stornierung musst du die Erstattung manuell im Buchungsdetail als erfolgt markieren.',
      refundPendingBox: 'Manuelle Erstattung erforderlich',
      markRefunded: 'Als erstattet markieren',
      waiveRefund: 'Auf Erstattung verzichten',
      refundNote: 'Notiz (optional)',
      refundNotePlaceholder: 'Stornogrund oder interne Notiz...',

      statusRefundPending: 'Erstattung ausstehend',
      statusRefundProcessing: 'Erstattung in Bearbeitung',
      statusRefundFailed: 'Erstattung fehlgeschlagen',
      statusRefundWaived: 'Erstattung verzichtet',

      toastCancelSuccess: 'Buchung storniert',
      toastRefundedMollie: 'Über Mollie erstattet',
      toastRefundPending: 'Storniert. Manuelle Erstattung ausstehend',
      toastRefundProcessing: 'Storniert. Erstattung in Bearbeitung',
      toastRefundFailed: 'Mollie-Erstattung fehlgeschlagen — manuell wiederholen',
      toastDeleted: 'Buchung endgültig gelöscht',
      toastMarkedRefunded: 'Buchung als erstattet markiert',
      toastRefundWaived: 'Erstattungsverzicht erfasst',

      forceRefundTitle: 'Mollie-Erstattung nicht erfasst',
      forceRefundDesc: 'Diese Buchung wurde storniert, aber die Mollie-Erstattung wurde nie ausgeführt. Du kannst sie jetzt manuell erzwingen.',
      forceRefundPaid: 'Gezahlter Betrag',
      forceRefundAmount: 'Zu erstattender Betrag',
      forceRefundBtn: 'Mollie-Erstattung erzwingen',
      forceRefundConfirm: 'Erstattung von €{amount} auf Mollie bestätigen?',
      forceRefundSuccess: 'Erstattung auf Mollie durchgeführt (€{amount})',
      forceRefundError: 'Erstattung fehlgeschlagen',
      forceRefundMollieId: 'Mollie-Zahlungs-ID',
    },

    settings: {
      securityTitle: 'Sicherheit & Test',
      securityDesc: 'Destruktive Operationen und reine Testfunktionen',
      hardDeleteToggle: 'Endgültige Löschung von Buchungen erlauben',
      hardDeleteDescription: 'Nur für Testumgebungen. Wenn aktiv, können Admins Buchungen dauerhaft aus der Datenbank löschen. In Produktion deaktiviert lassen.',
      hardDeleteOn: 'AKTIV',
      hardDeleteOff: 'INAKTIV',
      hardDeleteWarningProd: 'ACHTUNG: in Produktion muss diese Option DEAKTIVIERT bleiben. Löschungen sind unwiderruflich und entfernen historische Daten zu Zahlungen, Belegen und Audit-Logs.',
    },
  },

  // ============================================
  // SETTINGS
  // ============================================
  settings: {
    title: 'Konfiguration',
    subtitle: 'Verwalten Sie die Systemeinstellungen',
    saved: 'Einstellung gespeichert',
    invalidDays: 'Geben Sie einen Wert zwischen 1 und 90 ein',

    // Dashboard Layout
    dashboardLayout: 'Dashboard-Layout',
    dashboardLayoutDesc: 'Wählen Sie, wie die Tabs in den Admin- und Anbieter-Dashboards gruppiert werden',
    layoutAdmin: 'Admin-Dashboard',
    layoutVendor: 'Anbieter-Dashboard',
    layoutA: 'Kompakt',
    layoutADesc: 'Gruppiert die Tabs in wenige Makro-Bereiche',
    layoutB: 'Operative Priorität',
    layoutBDesc: 'Ausgewogenes Verhältnis zwischen Sichtbarkeit und Gruppierung',
    layoutC: 'Ultra-kompakt',
    layoutCDesc: 'Minimale Anzahl an Haupttabs',
    layoutTabs: 'Tabs',
    layoutCurrent: 'Aktuell',

    // Admin tab group labels
    layoutAdminFleet: 'Flotte',
    layoutAdminOperations: 'Betrieb',
    layoutAdminClientsServices: 'Kunden & Services',
    layoutAdminMarketplace: 'Marktplatz',
    layoutAdminFinance: 'Finanzen',
    layoutAdminManagement: 'Verwaltung',

    // Vendor tab group labels
    layoutVendorFleet: 'Flotte',
    layoutVendorOperations: 'Betrieb',
    layoutVendorServicesClients: 'Services & Kunden',
    layoutVendorManagement: 'Verwaltung',

    // Sub-tab labels
    subtabStats: 'Statistiken',
    subtabVendors: 'Anbieter',
    subtabBoatApproval: 'Bootsgenehmigung',
    subtabRevenue: 'Einnahmen',
    subtabPayouts: 'Auszahlungen',
    subtabPlatformStats: 'Plattform',
    autoCancellation: 'Automatische Stornierung ausstehender Buchungen',
    autoCancellationDesc: 'Wenn aktiviert, werden Buchungen im Status "Ausstehend" nach der angegebenen Anzahl von Tagen automatisch storniert.',
    enableAutoCancel: 'Automatische Stornierung aktivieren',
    autoCancelEnabled: 'Abgelaufene ausstehende Buchungen werden automatisch storniert',
    autoCancelDisabled: 'Ausstehende Buchungen werden nicht automatisch storniert',
    daysBeforeCancel: 'Tage bis zur Stornierung',
    daysBeforeCancelDesc: 'Anzahl der Tage, nach denen eine ausstehende Buchung storniert wird (1-90)',
    howItWorks: 'So funktioniert es',
    howItWorksDesc: 'Das System überprüft jeden Tag um Mitternacht die Buchungen im Status "Ausstehend" (PENDING). Wenn eine Buchung vor mehr als der angegebenen Anzahl von Tagen erstellt wurde und noch nicht bestätigt ist, wird sie automatisch mit dem Grund "Automatischer Ablauf" storniert.',

  },

  // ============================================
  // AUTH - LOGIN
  // ============================================
  login: {
    title: 'Willkommen zurück',
    subtitle: 'Melden Sie sich bei Ihrem Konto an',
    emailLabel: 'E-Mail',
    emailPlaceholder: 'ihre@email.com',
    passwordLabel: 'Passwort',
    passwordPlaceholder: '••••••••',
    submitButton: 'Anmelden',
    submittingButton: 'Anmeldung...',
    noAccount: 'Noch kein Konto? Registrieren',
    partnerRedirect: 'Partner müssen sich unter partner.insulacharter.it anmelden',
    testAccounts: 'Testkonten:',
    testGuest: 'Gast: turista@example.com',
    testAdmin: 'Admin: info@insulacharter.it',
    testPassword: 'Passwort: InsulaHost2026!',
    forgotPassword: 'Passwort vergessen?',
  },

  // ============================================
  // AUTH - FORGOT PASSWORD
  // ============================================
  forgotPassword: {
    title: 'Passwort vergessen',
    description: 'Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.',
    submitButton: 'Reset-Link senden',
    emailSentTitle: 'E-Mail gesendet!',
    emailSentDescription: 'Wenn die E-Mail registriert ist, erhalten Sie einen Link zum Zurücksetzen Ihres Passworts. Prüfen Sie auch den Spam-Ordner.',
    backToLogin: 'Zurück zum Login',
  },

  // ============================================
  // AUTH - RESET PASSWORD
  // ============================================
  resetPassword: {
    title: 'Neues Passwort',
    description: 'Wählen Sie ein neues Passwort für Ihr Konto.',
    newPasswordLabel: 'Neues Passwort',
    newPasswordPlaceholder: 'Geben Sie Ihr neues Passwort ein',
    confirmPasswordLabel: 'Passwort bestätigen',
    confirmPasswordPlaceholder: 'Wiederholen Sie Ihr neues Passwort',
    submitButton: 'Passwort zurücksetzen',
    successTitle: 'Passwort zurückgesetzt!',
    successDescription: 'Ihr Passwort wurde aktualisiert. Sie werden zum Login weitergeleitet...',
    invalidLink: 'Ungültiger Link',
    invalidLinkDescription: 'Der Reset-Link fehlt oder ist ungültig. Fordern Sie einen neuen Link an.',
    requestNewLink: 'Neuen Link anfordern',
    passwordMismatch: 'Passwörter stimmen nicht überein',
  },

  // ============================================
  // AUTH - PARTNER LOGIN
  // ============================================
  partnerLogin: {
    title: 'Partner Portal',
    subtitle: 'InsulaCharter — Geschützter Bereich',
    sectionLabel: 'Partner-Zugang',
    emailPlaceholder: 'email@beispiel.de',
    submit: 'Anmelden',
    submitting: 'Anmeldung...',
    accessDenied: 'Dieser Bereich ist Partnern vorbehalten. Bitte melden Sie sich auf der Hauptseite an.',
    copyright: 'Alle Rechte vorbehalten.',
  },

  // ============================================
  // PARTNERPROFIL (Vollständigkeit)
  // ============================================
  partnerProfile: {
    tab: { anagrafica: 'Stammdaten', documenti: 'Dokumente', account: 'Konto' },
    header: { verified: 'Verifiziert', pending: 'Ausstehend', ibanMissing: 'IBAN fehlt', manageIban: 'Einstellungen' },
    role: { VENDOR: 'Betreiber', COMPANY: 'Unternehmen', ADMIN: 'Admin' },
    completionTitle: 'Profilvollständigkeit',
    missing: 'Fehlt',
    allDone: 'Profil vollständig',
    loading: 'Profil wird geladen…',
    loadError: 'Fehler beim Laden des Profils',
    saved: 'Profil aktualisiert',
    saveError: 'Fehler beim Speichern',
    notSet: 'Nicht festgelegt',
    managePayout: 'In Einstellungen verwalten → Zahlungen & Auszahlungen',
    save: 'Profil speichern',
    saving: 'Speichern…',
    badgeComplete: 'Vollständig',
    badgeMissingOne: 'fehlt',
    badgeMissingMany: 'fehlen',
    bioPlaceholder: 'Beschreiben Sie Ihr Angebot (min. 30 Zeichen)…',
    bioHelper: 'Mindestens 30 Zeichen.',
    seasonHint: 'Standard für die gesamte Flotte. Leer lassen für "immer geöffnet".',
    seasonFrom: 'Von',
    seasonTo: 'Bis',
    docsHint: 'Die Dokumente werden vom InsulaCharter-Team geprüft.',
    docsUpload: 'Hochladen',
    docsReplace: 'Ersetzen',
    docStatusMissing: 'Hochzuladen',
    docStatusPending: 'In Prüfung',
    docStatusApproved: 'Verifiziert',
    docStatusRejected: 'Abgelehnt',
    docUploadError: 'Fehler beim Hochladen',
    docUploadOk: 'Dokument hochgeladen',
    emailVerifyTitle: 'E-Mail-Verifizierung',
    changePassword: 'Passwort ändern',
    currentPassword: 'Aktuelles Passwort',
    newPassword: 'Neues Passwort',
    confirmPassword: 'Neues Passwort bestätigen',
    pwUpdate: 'Passwort aktualisieren',
    pwUpdating: 'Aktualisiere…',
    pwMismatch: 'Die neuen Passwörter stimmen nicht überein',
    pwTooShort: 'Das neue Passwort muss mindestens 8 Zeichen haben',
    pwUpdated: 'Passwort aktualisiert',
    pwError: 'Fehler beim Ändern des Passworts',
    forgotTitle: 'Passwort vergessen?',
    forgotDesc: 'Erhalten Sie einen Link per E-Mail, um Ihr Passwort zurückzusetzen.',
    forgotCta: 'Passwort zurücksetzen →',
    suspendedOk: 'Buchungen ausgesetzt',
    reactivatedOk: 'Buchungen reaktiviert',
    section: {
      company: 'Unternehmensdaten',
      address: 'Geschäftsadresse',
      personal: 'Persönliche Daten',
      payout: 'Auszahlungsdaten',
      presentation: 'Präsentation',
      documents: 'Geschäftsdokumente',
      season: 'Buchungssaison',
      account: 'Konto und Sicherheit',
    },
    field: {
      company_name: 'Firmenname',
      company_vat: 'USt-IdNr.',
      company_pec: 'Zertifizierte E-Mail (PEC)',
      company_sdi: 'SDI-Code',
      vendor_phone: 'Telefon',
      address_street: 'Adresse',
      address_city: 'Stadt',
      address_province: 'Provinz',
      address_postal_code: 'PLZ',
      payout_iban: 'IBAN',
      payout_holder: 'Kontoinhaber',
      vendor_bio: 'Bio / Beschreibung',
      email_verified: 'E-Mail verifiziert',
      name: 'Name',
      email: 'E-Mail',
      BUSINESS_REGISTRATION: 'Handelsregisterauszug',
      VAT_CERTIFICATE: 'USt-Bescheinigung',
      INSURANCE: 'Haftpflichtversicherung',
    },
  },

  // BOOKING SUSPENDED OVERLAY
  // ============================================
  suspended: {
    title: 'Buchungen vorübergehend ausgesetzt',
    description: 'Wir aktualisieren unser Buchungssystem. Hinterlassen Sie Ihre E-Mail und wir benachrichtigen Sie, sobald Buchungen wieder möglich sind.',
    notifyLabel: 'Möchten Sie benachrichtigt werden?',
    emailPlaceholder: 'Ihre E-Mail',
    notifyBtn: 'Benachrichtigen bei Verfügbarkeit',
    sending: 'Wird gesendet...',
    error: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
    vendorTitle: 'Partner-Buchungen ausgesetzt',
    vendorDescription: 'Dieser Partner hat Buchungen für seine Boote vorübergehend ausgesetzt.',
    boatTitle: 'Boot-Buchungen ausgesetzt',
    boatDescription: 'Buchungen für dieses Boot sind vorübergehend ausgesetzt.',
    suspendVendorBookings: 'Partner-Buchungen sperren',
    unsuspendVendorBookings: 'Partner-Buchungen freigeben',
    suspendVendorBookingsDesc: 'Buchungen für alle Boote dieses Partners blockieren.',
    suspendMyBookings: 'Meine Buchungen pausieren',
    unsuspendMyBookings: 'Meine Buchungen fortsetzen',
    suspendMyBookingsDesc: 'Buchungen für alle Ihre Boote pausieren (z.B. Urlaubszeit).',
    suspendBoatBookings: 'Buchungen sperren',
    unsuspendBoatBookings: 'Buchungen freigeben',
    byAdmin: 'Vom Administrator gesperrt',
  },

  // ============================================
  // COOKIE CONSENT
  // ============================================
  cookie: {
    title: 'Datenschutz an Bord',
    description: 'Wir verwenden Cookies, um Ihnen ein optimales Surferlebnis zu bieten und Ihre nächsten Routen auf Sardinien zu personalisieren.',
    acceptAll: 'Alle akzeptieren',
    decline: 'Ablehnen',
    advancedPrefs: 'Erweiterte Einstellungen',
    savePrefs: 'Einstellungen speichern',
    alwaysActive: 'immer aktiv',
    necessary: 'Notwendig',
    necessaryDesc: 'Wesentliche Cookies für die Funktion der Website. Sie können nicht deaktiviert werden.',
    analytics: 'Analytik',
    analyticsDesc: 'Helfen uns zu verstehen, wie Sie die Seite nutzen, um Ihr Erlebnis zu verbessern.',
    marketing: 'Marketing',
    marketingDesc: 'Werden verwendet, um Ihnen relevante Angebote und Aktionen anzuzeigen.',
    preferences: 'Präferenzen',
    preferencesDesc: 'Speichern Ihre Auswahl wie Sprache und Navigationsgebiet.',
  },

  // ============================================
  // AUTH - REGISTER
  // ============================================
  register: {
    title: 'Konto erstellen',
    subtitle: 'Starten Sie Ihr Abenteuer auf dem Meer',
    nameLabel: 'Vollständiger Name',
    namePlaceholder: 'Max Mustermann',
    emailLabel: 'E-Mail',
    emailPlaceholder: 'ihre@email.com',
    passwordLabel: 'Passwort',
    passwordPlaceholder: '••••••••',
    passwordHelper: 'Min. 8 Zeichen, Großbuchstabe, Kleinbuchstabe, Zahl, Sonderzeichen',
    confirmPasswordLabel: 'Passwort bestätigen',
    passwordMismatch: 'Die Passwörter stimmen nicht überein',
    submitButton: 'Registrieren',
    submittingButton: 'Registrierung...',
    hasAccount: 'Bereits ein Konto? Anmelden',
    // Role selection
    roleLabel: 'Kontotyp',
    roleGuest: 'Tourist',
    roleGuestDesc: 'Boote und Dienste buchen',
    roleVendor: 'Eigentümer',
    roleVendorDesc: 'Vermieten Sie Ihr Boot',
    roleAgency: 'Agentur',
    roleAgencyDesc: 'Boote und Dienste von Unternehmen weiterverkaufen',
    roleCompany: 'Unternehmen',
    roleCompanyDesc: 'Verwalten Sie eine Bootsflotte',
    roleServiceProvider: 'Dienstleister',
    roleServiceProviderDesc: 'Dienstleistungen für Boote und Kunden anbieten',
    roleServiceProviderDisabled: 'Nur auf Einladung',
    roleExcursion: 'Ausflüge-Anbieter',
    roleExcursionDesc: 'Schnorcheln, Touren, Trekking — nur Ausflüge',
    providesExcursionsLabel: 'Ich biete auch geführte Ausflüge an',
    providesExcursionsHelp: 'Aktivieren, wenn dein Unternehmen sowohl Charter als auch Ausflüge anbietet: Zugriff auf beide Dashboards.',
    companyTypeTitle: 'Was macht dein Unternehmen?',
    companyTypeSubtitle: 'Wähle den Aktivitätstyp, um die passenden Funktionen freizuschalten',
    serviceTypeTitle: 'Was bietest du an?',
    serviceTypeSubtitle: 'Wähle alle Dienste, die du anbietest (mehrere möglich)',
    art49Title: 'Du bist Privatperson: gelegentliche Vercharterung (Art. 49-bis)',
    art49Intro: 'Als Privatperson ohne USt-IdNr. kannst du dein Boot gelegentlich vermieten oder verchartern. Kernpunkte:',
    art49P1: 'Maximal 42 Tage pro Jahr insgesamt (Vermietung, Ausflüge und Erlebnisse).',
    art49P2: 'Begünstigte Besteuerung: 20% Pauschalsteuer auf die Einnahmen (auf Antrag).',
    art49P3: 'Es gilt nicht als gewerbliche Tätigkeit.',
    art49P4: 'Über der Grenze ist eine USt-IdNr. erforderlich: Registrierung als Unternehmen.',
    art49Disclaimer: 'Referenz: Art. 49-bis ital. Freizeitschifffahrtsgesetzbuch (GvD 171/2005). Richtwert, keine Steuerberatung.',
    vatLookupCta: 'Daten aus USt-IdNr. holen',
    vatSearching: 'Suche…',
    vatAutofilled: 'Automatisch ausgefüllt — prüfen und ggf. anpassen',
    vatEnterFirst: 'Zuerst die USt-IdNr. eingeben',
    vatInvalid: 'Ungültige USt-IdNr.',
    vatError: 'Fehler beim Abruf',
    vatNetworkError: 'Netzwerkfehler',
    vatLookupHint: 'USt-IdNr. eingeben und „Holen“ drücken, um Firmenname, PEC und Adresse vorauszufüllen (danach editierbar).',
    companyTypeCharter: 'Charter / Bootsvermietung',
    companyTypeCharterDesc: 'Verwalte eine Flotte zur Vermietung',
    companyTypeExcursion: 'Nur Ausflüge',
    companyTypeExcursionDesc: 'Schnorcheln, geführte Touren, Trekking, Verkostungen — keine Vermietung',
    companyTypeMixed: 'Charter + Ausflüge',
    companyTypeMixedDesc: 'Du bietest beides: Zugriff auf beide Dashboards im selben Partnerbereich',
    serviceProviderSectionTitle: 'Anbieter-Informationen',
    vendorSectionTitle: 'Eigentümer-Informationen',
    vendorPhoneLabel: 'Telefon',
    vendorPhonePlaceholder: '+39 333...',
    companySectionTitle: 'Unternehmensdaten',
    companyNameLabel: 'Firmenname',
    companyNamePlaceholder: 'Firmenname GmbH',
    companyVatLabel: 'USt-IdNr.',
    companyVatPlaceholder: 'IT12345678901',
    companyPecLabel: 'PEC',
    companySdiLabel: 'SDI-Code',
    spSectionTitle: 'Anbieterinformationen',
    spLicenseLabel: 'Lizenznummer',
    spLicensePlaceholder: 'z.B. ABC-12345',
    spServiceAreaLabel: 'Servicegebiet',
    spServiceAreaPlaceholder: 'z.B. Alghero, Sassari...',
    spFleetSizeLabel: 'Anzahl Fahrzeuge',
    passwordStrengthWeak: 'Schwach',
    passwordStrengthFair: 'Ausreichend',
    passwordStrengthGood: 'Gut',
    passwordStrengthStrong: 'Stark',
    pendingApprovalInfo: 'Dieser Kontotyp erfordert eine Genehmigung durch das Team.',
    pendingApprovalTitle: 'Registrierung eingereicht',
    pendingApprovalMessage: 'Ihr Konto wurde erfolgreich erstellt. Unser Team wird Ihre Daten überprüfen und Ihr Profil genehmigen.',
    pendingApprovalStep1: '1. Konto erfolgreich erstellt',
    pendingApprovalStep2: '2. Warten auf Team-Überprüfung',
    pendingApprovalStep3: '3. Sie erhalten eine E-Mail-Benachrichtigung',
    backToHome: 'Zurück zur Startseite',
  },

  // ============================================
  // MAINTENANCE PAGE
  // ============================================
  maintenance: {
    title: 'Seite in Wartung',
    message: 'Wir aktualisieren die Seite, um Ihnen ein besseres Erlebnis zu bieten. Wir sind in Kürze wieder online.',
    footer: 'InsulaCharter - Bootsverleih auf Sardinien',
  },

  // ============================================
  // LANDING PAGE (Pre-launch)
  // ============================================
  landing: {
    title: 'InsulaCharter',
    subtitle: 'Wir arbeiten für Sie',
    message1: 'Unsere neue Website befindet sich in der Entwicklung.',
    message2: 'Bald können Sie die besten Mietboote auf Sardinien entdecken.',
    needInfo: 'Benötigen Sie Informationen?',
    devAccess: 'Entwicklerzugang',
    devLoginTitle: 'Entwicklerzugang',
    devLoginMessage: 'Geben Sie das Passwort ein, um auf die Seite zuzugreifen',
    wrongPassword: 'Falsches Passwort',
    copyright: '© 2026 InsulaCharter - Bootsverleih auf Sardinien',
  },

  // ============================================
  // TOAST MESSAGES
  // ============================================
  toast: {
    bookingCreated: 'Buchung erfolgreich erstellt!',
    bookingCancelled: 'Buchung erfolgreich storniert!',
    bookingError: 'Fehler bei der Erstellung der Buchung: ',
    boatCreated: 'Boot erfolgreich hinzugefügt!',
    boatUpdated: 'Boot erfolgreich aktualisiert!',
    boatDeleted: 'Boot erfolgreich gelöscht!',
    maxPhotos: 'Sie können maximal 10 Fotos hinzufügen',
    nameMinLength: 'Der Name muss mindestens 3 Zeichen haben',
    descriptionMinLength: 'Die Beschreibung muss mindestens 10 Zeichen haben',
    serviceExists: 'Es existiert bereits ein Service mit diesem Namen',
  },

  // ============================================
  // CONFIRM DIALOGS
  // ============================================
  confirm: {
    cancelBooking: 'Möchten Sie die Buchung stornieren?',
    deleteBoat: 'Möchten Sie dieses Boot wirklich aus der InsulaCharter-Flotte entfernen?',
    deleteServiceUsed: 'Dieser Service wird in {count} Booten verwendet. Möchten Sie ihn trotzdem löschen?',
    deleteService: 'Möchten Sie diesen Service löschen?',
  },

  // ============================================
  // LANGUAGE SELECTOR
  // ============================================
  language: {
    select: 'Sprache',
    it: 'Italienisch',
    en: 'Englisch',
    de: 'Deutsch',
  },

  // ============================================
  // CALENDAR
  // ============================================
  calendar: {
    available: 'Verfügbar',
    booked: 'Gebucht',
    pending: 'Ausstehend',
    blocked: 'Nicht verfügbar',
    yourSelection: 'Ihre Auswahl',
    selectDates: 'Daten auswählen',
    pickupDate: 'Abholung',
    returnDate: 'Rückgabe',
    days: 'Tage',
    day: 'Tag',
    clearSelection: 'Auswahl löschen',
    confirmDates: 'Daten bestätigen',
    availability: 'Verfügbarkeit',
    selectPickup: 'Wählen Sie das Abholdatum',
    selectReturn: 'Wählen Sie das Rückgabedatum',
    // Booking detail modal
    bookingDetails: 'Buchungsdetails',
    boat: 'Boot',
    client: 'Kunde',
    period: 'Zeitraum',
    passengers: 'Passagiere',
    total: 'Gesamt',
    basePrice: 'Miete',
    insuranceFee: 'Versicherung',
    extras: 'Extras',
    specialRequests: 'Sonderwünsche',
    createdAt: 'Erstellt am',
    unavailable: 'Nicht verfügbar',
    paymentMethod: 'Zahlungsmethode',
  },

  // ============================================
  // ICAL SYNC
  // ============================================
  ical: {
    title: 'iCal-Synchronisierung',
    titleWithBoat: 'iCal-Synchronisierung — {boatName}',
    exportUrl: 'Export-URL',
    exportHint: 'Verwenden Sie diese URL, um den Kalender auf anderen Plattformen zu importieren (Airbnb, Booking.com, MMK Booking Manager usw.)',
    importedFeeds: 'Importierte Feeds',
    addFeed: 'Feed hinzufügen',
    feedUrlPlaceholder: 'iCal-Feed-URL',
    feedLabelPlaceholder: 'Bezeichnung (optional)',
    cancel: 'Abbrechen',
    adding: 'Wird hinzugefügt...',
    add: 'Hinzufügen',
    noFeeds: 'Keine Feeds importiert',
    events: 'Ereignisse',
    error: 'Fehler',
    lastSync: 'Letzte Synchronisierung',
    confirmDelete: 'Diesen iCal-Feed löschen?',
    syncNow: 'Jetzt synchronisieren',
    openFeed: 'Feed öffnen',
    deleteFeed: 'Feed löschen',
    sourceAirbnb: 'Airbnb',
    sourceBooking: 'Booking.com',
    sourceGoogle: 'Google Kalender',
    sourceMmk: 'MMK Booking Manager',
    sourceOther: 'Sonstige',
    guideTitle: 'So verbinden Sie Ihren externen Kalender',
    guideStep1: '1. Kopieren Sie die obige Export-URL und fügen Sie sie auf der externen Plattform (MMK, Airbnb usw.) als "externer Kalender" oder "iCal-Feed" ein',
    guideStep2: '2. Kopieren Sie auf der externen Plattform die Kalender-URL Ihres Fahrzeugs und fügen Sie sie unten ein, indem Sie auf "Feed hinzufügen" klicken',
    guideStep3: '3. Die Synchronisierung erfolgt automatisch alle 15 Minuten. Sie können sie mit der Schaltfläche "Jetzt synchronisieren" erzwingen',
    boatsTitle: 'Boote zur Vermietung',
    excursionsTitle: 'Ausflüge & Erlebnisse',
    excursionsHint: 'Veröffentlichen Sie die Abfahrten Ihrer Ausflüge/Erlebnisse in externen Kalendern (nur Export).',
    excursionsEmpty: 'Keine Ausflüge oder Erlebnisse',
    copyExportUrl: 'Kopieren',
    manageFeeds: 'Feeds verwalten',
  },

  // ============================================
  // BOOKING (Buchungen)
  // ============================================
  booking: {
    bookingSuspensionToggled: 'Status der Buchungssperrung aktualisiert',
    confirmed: 'Bestätigt',
    pending: 'Ausstehend',
    cancelled: 'Storniert',
    completed: 'Abgeschlossen',
    refunded: 'Erstattet',
    awaitingPayment: 'Zahlung ausstehend',
    pendingLateBooking: 'Bestätigung ausstehend',
    payNow: 'Jetzt bezahlen',
    startingPayment: 'Wird gestartet…',
    paymentStartFailed: 'Zahlung konnte nicht gestartet werden. Bitte erneut versuchen.',
    networkErrorRetry: 'Netzwerkfehler. Bitte erneut versuchen.',
    modify: 'Bearbeiten',
    cancel: 'Stornieren',
    receipt: 'Quittung',
    paid: 'Bezahlt',
    notPaid: 'Zu bezahlen',
    partiallyPaid: 'Teilweise',
    depositPaid: 'Anzahlung geleistet',
    depositRefunded: 'Anzahlung erstattet',
    paymentFailed: 'Fehlgeschlagen',
    departurePoint: 'Abfahrtsort',
    departurePointRequired: 'Wähle einen Abfahrtsort',
    departureFrom: 'Abfahrt von',
  },

  // ============================================
  // CANCELLATION REQUEST (kundengesteuert)
  // ============================================
  cancellation: {
    reasonBadWeather: 'Schlechtes Wetter',
    reasonBadWeatherHint: 'Raue See, offizielle Warnung, unsichere Bedingungen',
    reasonHealth: 'Gesundheitliche Gründe',
    reasonHealthHint: 'Krankheit oder Verletzung des Buchungsinhabers',
    reasonEmergency: 'Notfall',
    reasonEmergencyHint: 'Schwerwiegender familiärer oder beruflicher Notfall',
    reasonForceMajeure: 'Höhere Gewalt',
    reasonForceMajeureHint: 'Unkontrollierbare Ereignisse (z. B. Sperrungen, Trauerfall)',
    reasonOther: 'Anderer Grund',
    reasonOtherHint: 'Gib den Grund in der Beschreibung an',
    requestSentTitle: 'Stornierungsanfrage gesendet',
    requestSentDesc: 'Der Anbieter prüft deine Anfrage. Du erhältst eine Antwort per E-Mail.',
    reasonLabel: 'Grund:',
    rejectedTitle: 'Anfrage nicht genehmigt',
    rejectedDefaultDesc: 'Der Anbieter hat die Stornierungsanfrage abgelehnt.',
    newRequest: 'Neue Anfrage senden',
    approvedTitle: 'Stornierung genehmigt',
    approvedDesc: 'Eine eventuelle Rückerstattung erfolgt über die ursprüngliche Zahlungsmethode.',
    requestCta: 'Stornierung beantragen',
    formTitle: 'Stornierungsanfrage aus triftigem Grund',
    formSubtitle: 'Wähle einen Grund. Der Anbieter prüft die Anfrage und kann sie genehmigen oder ablehnen.',
    description: 'Beschreibung',
    descriptionPlaceholderOther: 'Erkläre den Grund der Anfrage (erforderlich bei "Anderer Grund")',
    descriptionPlaceholderDefault: 'Füge dem Anbieter nützliche Details hinzu (optional)',
    minChars: 'Mindestens 10 Zeichen',
    cancel: 'Abbrechen',
    sending: 'Wird gesendet…',
    sendRequest: 'Anfrage senden',
    sendFailed: 'Senden fehlgeschlagen',
    unknownError: 'Unbekannter Fehler',
  },

  // ============================================
  // REVIEW FORM
  // ============================================
  review: {
    selectRating: 'Wähle eine Gesamtbewertung.',
    writeComment: 'Schreibe einen Kommentar.',
    submitError: 'Fehler beim Senden der Bewertung.',
    overallRating: 'Gesamtbewertung *',
    titleLabel: 'Titel (optional)',
    titlePlaceholder: 'Fasse deine Erfahrung zusammen',
    commentLabel: 'Kommentar *',
    commentPlaceholder: 'Erzähl von deiner Erfahrung...',
    detailedRatings: 'Detaillierte Bewertungen (optional)',
    boatCondition: 'Zustand des Boots',
    itinerary: 'Route',
    valueForMoney: 'Preis-Leistung',
    communication: 'Kommunikation',
    sending: 'Wird gesendet...',
    submit: 'Bewertung senden',
  },

  // ============================================
  // AMBASSADOR (Banner + Einladungscodes)
  // ============================================
  ambassador: {
    requestSent: 'Anfrage gesendet',
    genericError: 'Fehler',
    codeCopied: 'Code kopiert!',
    copyFailed: 'Kopieren nicht möglich',
    linkCopied: 'Link kopiert!',
    linkCopyFailed: 'Link konnte nicht kopiert werden',
    youAreAmbassador: 'Du bist ein Ambassador!',
    commissionPct: '{rate}% Provision',
    copyCode: 'Code kopieren',
    copyInviteLink: 'Einladungslink kopieren',
    peopleReferred: 'geworbene Personen',
    viaCode: ' · {used} über Code',
    withYourCode: ' mit deinem Code',
    generateLink: 'Link generieren',
    pendingTitle: 'Ambassador-Anfrage ausstehend',
    pendingDesc: 'Unser Team prüft deine Anfrage',
    rejectedDesc: 'Deine Ambassador-Anfrage wurde nicht genehmigt.',
    becomeAmbassador: 'Werde Ambassador',
    becomeAmbassadorDesc: 'Verdiene eine Provision für jeden Nutzer, den du auf die Plattform bringst',
    sendingRequest: 'Wird gesendet...',
    applyRequest: 'Ambassador werden beantragen',
  },

  // ============================================
  // AMBASSADOR CODES MANAGER (Mehrfachcodes + Empfehlungen)
  // ============================================
  ambassadorCodes: {
    roleCustomer: 'Kunde',
    roleAgency: 'Agentur',
    roleCollaborator: 'Mitarbeiter',
    roleVendor: 'Vendor',
    roleCompany: 'Unternehmen',
    roleAdmin: 'Admin',
    roleServiceProvider: 'Anbieter',
    roleHost: 'Host',
    codeActivated: 'Code aktiviert',
    codeDeactivated: 'Code deaktiviert',
    codeCreated: 'Code {code} erstellt',
    createError: 'Fehler beim Erstellen',
    loadingCodes: 'Codes werden geladen...',
    myInviteCodes: 'Meine Einladungscodes',
    newCode: 'Neuer Code',
    deactivated: 'Deaktiviert',
    exhausted: 'Aufgebraucht',
    uses: 'Verwendungen',
    reactivate: 'Reaktivieren',
    deactivate: 'Deaktivieren',
    peopleBrought: 'Geworbene Personen',
    noPeopleYet: 'Noch niemand geworben.',
    tableName: 'Name',
    tableType: 'Typ',
    tableOrigin: 'Herkunft',
    tableDate: 'Datum',
    manual: 'Manuell',
    viaCodeOrigin: 'Code',
    newCodeModalTitle: 'Neuer Einladungscode',
    newCodeModalSubtitle: 'Erstelle einen Code für eine bestimmte Kampagne',
    creating: 'Wird erstellt...',
    createCode: 'Code erstellen',
    label: 'Bezeichnung',
    optional: '(optional)',
    labelPlaceholder: 'z. B. Sommerkampagne 2026',
    labelHint: 'Nur für deine Organisation — nicht öffentlich sichtbar.',
    maxUses: 'Maximale Verwendungen',
    maxUsesPlaceholder: 'Unbegrenzt, wenn leer',
    maxUsesHint: 'Wie oft der Code verwendet werden kann, bevor er aufgebraucht ist.',
    commissionNote: 'Die Provision wird von deinem Hauptcode übernommen. Nur ein Administrator kann den Prozentsatz ändern.',
  },

  // ============================================
  // PROFILE
  // ============================================
  profile: {
    // Page header
    myProfile: 'Mein Profil',
    manageYourAccount: 'Verwalten Sie Ihre persönlichen Daten, Dokumente und Zahlungseinstellungen',

    // Sections
    personalData: 'Persönliche Daten',
    address: 'Wohnadresse',
    phoneNumber: 'Telefonnummer',
    documents: 'Ausweisdokumente',
    profilePhoto: 'Profilbild',

    // Personal data fields
    firstName: 'Vorname',
    firstNamePlaceholder: 'Geben Sie Ihren Vornamen ein',
    lastName: 'Nachname',
    lastNamePlaceholder: 'Geben Sie Ihren Nachnamen ein',
    dateOfBirth: 'Geburtsdatum',
    nationality: 'Staatsangehörigkeit',
    nationalityPlaceholder: 'Wählen Sie Ihre Staatsangehörigkeit',
    fiscalCode: 'Steuernummer',
    fiscalCodePlaceholder: 'z.B.: RSSMRA80A01H501U',
    fiscalCodeHelper: 'Optional - Nur für italienische Staatsbürger',

    // Address fields
    street: 'Straße/Adresse',
    streetPlaceholder: 'Musterstraße 123',
    city: 'Stadt',
    cityPlaceholder: 'z.B.: Olbia',
    postalCode: 'PLZ',
    postalCodePlaceholder: 'z.B.: 07026',
    province: 'Bundesland/Provinz',
    provincePlaceholder: 'z.B.: SS',
    country: 'Land',
    countryPlaceholder: 'Land auswählen',

    // Phone fields
    mobilePhone: 'Mobiltelefon',
    phoneHelper: 'Geben Sie nur Zahlen ein, ohne Leerzeichen oder Bindestriche',

    // Document fields
    documentType: 'Dokumenttyp',
    selectDocumentType: 'Dokumenttyp auswählen...',
    identityCard: 'Personalausweis',
    passport: 'Reisepass',
    drivingLicense: 'Führerschein',
    boatLicense: 'Bootsführerschein',
    documentNumber: 'Dokumentnummer',
    documentNumberPlaceholder: 'z.B.: AB1234567',
    documentExpiry: 'Ablaufdatum',
    frontImage: 'Vorderseite',
    backImage: 'Rückseite (optional)',
    clickToUpload: 'Zum Hochladen klicken',
    addDocument: 'Dokument hinzufügen',
    uploadDocument: 'Dokument hochladen',
    noDocuments: 'Keine Dokumente hochgeladen',
    expiresOn: 'Gültig bis',
    verified: 'Verifiziert',
    pending: 'Überprüfung ausstehend',
    confirmDeleteDocument: 'Möchten Sie dieses Dokument löschen?',
    requiredFields: 'Füllen Sie alle Pflichtfelder aus',
    documentTooLarge: 'Die Datei ist zu groß. Maximal 10 MB.',

    // Avatar
    uploadPhoto: 'Foto hochladen',
    deletePhoto: 'Entfernen',
    confirmDeleteAvatar: 'Möchten Sie das Profilbild entfernen?',
    cropImage: 'Bild zuschneiden',
    zoom: 'Zoom',
    rotate: 'Drehen',
    invalidImageType: 'Ungültiger Dateityp. Verwenden Sie PNG, JPG oder PDF.',
    imageTooLarge: 'Das Bild ist zu groß. Maximal 5 MB.',

    // Email verification
    emailVerification: 'E-Mail-Verifizierung',
    emailVerified: 'E-Mail Verifiziert',
    emailNotVerified: 'E-Mail nicht verifiziert',
    verify: 'Verifizieren',
    clickToVerify: 'Zum Verifizieren klicken',
    resendVerification: 'Verifizierungs-E-Mail erneut senden',
    emailVerificationDescription: 'Verifizieren Sie Ihre E-Mail, um alle Funktionen Ihres Kontos freizuschalten.',
    sendVerificationEmail: 'Verifizierungs-E-Mail senden',
    verificationEmailSent: 'Verifizierungs-E-Mail gesendet! Überprüfen Sie Ihren Posteingang.',

    // User profile page
    loginToViewProfile: 'Melden Sie sich an, um Ihr Profil anzuzeigen.',
    myBookings: 'Buchungen',
    noBookings: 'Keine Buchungen',
    unknownBoat: 'Unbekanntes Boot',
    guest: 'Gast',
    memberSince: 'Mitglied seit',
    bookingDetails: 'Buchungsdetails',
    embarkationPoint: 'Einschiffungspunkt',
    length: 'Länge',
    maxCapacity: 'Max. Kapazität',
    bookingStatus: 'Buchungsstatus',
    totalPaid: 'Gesamtbetrag bezahlt',
    contactSkipper: 'Skipper kontaktieren',

    downloadReceipt: 'Quittung herunterladen',

    // Success/Error messages
    updateSuccess: 'Profil erfolgreich aktualisiert!',

    // Profile save (customer form)
    profileUpdated: 'Profil aktualisiert',
    saveError: 'Fehler beim Speichern',
    saving: 'Wird gespeichert…',
    saveProfile: 'Profil speichern',

    // Tab-Bereiche
    documentsTitle: 'Dokumente',
    documentsSubtitle: 'Lade deinen Ausweis und Bootsführerschein hoch',
    paymentMethodsSubtitle: 'Gespeicherte Karten und Zahlungsmethoden',
    savedBoats: 'Die Boote, die du gespeichert hast',
    ambassadorTab: 'Ambassador',
    ambassadorProgram: 'Ambassador-Programm',
    ambassadorProgramDesc: 'Lade Freunde ein und verdiene Provisionen auf Vermietungen',

    // Stats hero
    upcoming: 'Bevorstehend',
    total: 'Insgesamt',
    nextDeparture: 'Nächste Abfahrt',
    today: 'Heute',
    tomorrow: 'Morgen',
    inDays: 'In {n} Tagen',
    bookingDetailsCta: 'Buchungsdetails',

    // Buchungsliste
    bookingSentSuccess: 'Buchung erfolgreich gesendet',
    bookingSentSuccessDesc: 'Du erhältst eine Bestätigung per E-Mail, sobald der Eigentümer die Anfrage genehmigt.',
    noBookingsYet: 'Noch keine Buchungen',
    noBookingsDesc: 'Suche ein Boot und buche dein erstes Meereserlebnis.',
    searchBoat: 'Boot suchen',
    boatsSection: 'Boote',
    experiencesSection: 'Erlebnisse',
    experienceFallback: 'Erlebnis',
    awaitingOperator: 'Bestätigung des Anbieters ausstehend',
    reviewed: 'Bewertet',
    leaveReview: 'Bewertung abgeben',
    reviewSubmittedPending: 'Bewertung gesendet, ausstehende Freigabe.',
    leaveReviewModalTitle: 'Bewertung abgeben',
    leaveReviewModalSubtitle: 'Deine Meinung hilft anderen Reisenden',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    bookingCountOne: '{count} Buchung',
    bookingCountOther: '{count} Buchungen',
    notSet: 'Nicht festgelegt',
    exampleCityPlaceholder: 'Z. B.: Olbia',
    exampleVatPlaceholder: 'Z. B.: 01692360918',
  },

  // ============================================
  // FAVORITES
  // ============================================
  favorites: {
    title: 'Favoriten',
    empty: 'Keine Favoriten gespeichert',
    emptyHint: 'Tippen Sie auf das Herz bei Booten, um sie hier zu speichern.',
    remove: 'Aus Favoriten entfernen',
    added: 'Zu Favoriten hinzugefügt',
    removed: 'Aus Favoriten entfernt',
  },

  // ============================================
  // PAYMENTS
  // ============================================
  payments: {
    paymentMethods: 'Zahlungsmethoden',
    addMethod: 'Methode hinzufügen',
    noMethods: 'Keine gespeicherten Zahlungsmethoden',
    addFirstMethod: 'Fügen Sie Ihre erste Zahlungsmethode hinzu',
    selectType: 'Zahlungsart auswählen',
    creditCard: 'Kreditkarte',
    bankTransfer: 'Banküberweisung',
    cash: 'Bargeld',
    default: 'Standard',
    setAsDefault: 'Als Standard festlegen',
    confirmDelete: 'Möchten Sie diese Zahlungsmethode löschen?',

    // Credit Card
    cardNumber: 'Kartennummer',
    cardHolder: 'Karteninhaber',
    expiryDate: 'Ablaufdatum',
    expires: 'Gültig bis',
    cardSecurityNote: 'Zu Ihrer Sicherheit speichern wir weder die vollständige Kartennummer noch die CVV.',

    // PayPal
    paypalEmail: 'PayPal E-Mail',

    // IBAN
    accountHolder: 'Kontoinhaber',
    bankName: 'Bankname',

    // Common
    label: 'Bezeichnung',
    labelPlaceholder: 'z.B.: Persönliche Karte, Geschäftskonto',
    optional: 'Optional',
  },

  // ============================================
  // EQUIPMENT (Bordausstattung)
  // ============================================
  equipment: {
    gps: { label: 'GPS Kartenplotter', description: 'GPS-Navigationssystem mit Seekartenplotter' },
    vhf: { label: 'UKW-Seefunk', description: 'Seefunkgerät für Notfallkommunikation' },
    anchor: { label: 'Anker mit Kette', description: 'Kompletter Anker mit Kette und Leine' },
    lifejackets: { label: 'Rettungswesten', description: 'Rettungswesten für alle Passagiere' },
    bimini: { label: 'Bimini-Verdeck', description: 'Sonnensegel als Sonnenschutz' },
    shower: { label: 'Heckdusche', description: 'Süßwasserdusche am Heck' },
    cooler: { label: 'Tragbare Kühlbox', description: 'Tragbarer Kühlschrank für Getränke und Speisen' },
    bluetooth: { label: 'Bluetooth-Stereo', description: 'Soundsystem mit Bluetooth-Verbindung' },
    ladder: { label: 'Badeleiter', description: 'Ausziehbare Leiter für einfachen Zugang zum Meer' },
    cushions: { label: 'Sonnenliegekissen', description: 'Gepolsterte Kissen zum Entspannen in der Sonne' },
  },

  // ============================================
  // EXTRAS (Zusatzleistungen)
  // ============================================
  extras: {
    skipper: { label: 'Professioneller Skipper', description: 'Erfahrener Kapitän für die Navigation' },
    hostess: { label: 'Bord-Hostess', description: 'Betreuung und Service an Bord' },
    fuel: { label: 'Volltankung', description: 'Voller Tank im Preis inbegriffen' },
    snorkeling: { label: 'Schnorchel-Set', description: 'Maske, Schnorchel und Flossen' },
    sup: { label: 'Stand Up Paddle', description: 'SUP-Board mit Paddel' },
    towable: { label: 'Schleppbares Wassergerät', description: 'Aufblasbares Schleppgerät für Wasserspaß' },
  },

  // ============================================
  // EXCURSION OPERATOR DASHBOARD
  // ============================================
  excursion: {
    dashboard: 'Ausflüge-Panel',
    dashboardTitle: 'Ausflüge-Dashboard',
    dashboardTitleCompany: 'Betreiber-Dashboard',
    dashboardSubtitle: 'Verwalte Katalog, Slots und Buchungen',
    menuMain: 'Hauptmenü',
    menuFleet: 'Katalog',
    menuOperations: 'Betrieb',
    menuFinance: 'Finanzen',
    menuSettings: 'Einstellungen',
    fleet: 'Ausflug-Katalog',
    calendar: 'Kalender',
    availability: 'Verfügbarkeit',
    pricing: 'Preise',
    extras: 'Zusatzleistungen',
    bookings: 'Buchungen',
    requests: 'Sonderanfragen',
    customRequests: 'Anfragen',
    clients: 'Kunden',
    reviews: 'Bewertungen',
    coupons: 'Gutscheine',
    team: 'Team',
    earnings: 'Einnahmen',
    earningsByChannel: 'Einnahmen nach Kanal',
    reports: 'Berichte',
    notifications: 'Benachrichtigungen',
    profile: 'Profil',
    settings: 'Einstellungen',
    guide: 'Bedienerhandbuch',
    roleCompany: 'Unternehmen',
    roleVendor: 'Betreiber',
  },
  partner: {
    menuServices: 'Dienste',
    locazione: 'Vermietung',
    escursioni: 'Ausflüge',
    esperienze: 'Erlebnisse',
    disponibilita: 'Verfügbarkeit',
    calendarioPartenze: 'Abfahrtskalender',
  },

  // ============================================
  // EXCURSION FLOW — DE fallback (TODO: translate; for now keeps EN strings)
  // ============================================
  customRequests: {
    title: 'Preisanfragen',
    subtitle: 'Individuelle Preisanfragen von Kunden',
    refresh: 'Aktualisieren',
    filterActionable: 'Zu bearbeiten',
    filterAll: 'Alle',
    empty: 'Noch keine Preisanfragen.',
    deletedExcursion: 'Entferntes Erlebnis',
    status: {
      PENDING: 'Neu',
      VENDOR_PROPOSED: 'Angebot gesendet',
      CUSTOMER_COUNTER: 'Gegenangebot Kunde',
      ACCEPTED: 'Angenommen',
      REJECTED: 'Abgelehnt',
      EXPIRED: 'Abgelaufen',
      CONVERTED: 'Gebucht',
    },
    drawerTitle: 'Anfragedetail',
    noActivity: 'Noch keine Aktivität.',
    you: 'Sie',
    customer: 'Kunde',
    validUntil: 'Gültig bis',
    slotStart: 'Beginn',
    slotEnd: 'Ende',
    sendProposal: 'Angebot senden',
    proposalSent: 'Angebot an den Kunden gesendet.',
    priceInvalid: 'Gültigen Preis eingeben.',
    pricePlaceholder: 'Preis €',
    notesPlaceholder: 'Hinweise für den Kunden (optional)',
    messagePlaceholder: 'Nachricht schreiben…',
    reject: 'Anfrage ablehnen',
    rejected: 'Anfrage abgelehnt.',
    rejectReasonPlaceholder: 'Grund (optional)',
    confirmReject: 'Ablehnung bestätigen',
  },
  myRequests: {
    title: 'Meine Anfragen',
    subtitle: 'Angeforderte Angebote und erhaltene Vorschläge',
    back: 'Zurück zu den Anfragen',
    empty: 'Sie haben noch keine Preisanfragen.',
    deletedExcursion: 'Entferntes Erlebnis',
    status: {
      PENDING: 'Warten auf Antwort',
      VENDOR_PROPOSED: 'Angebot erhalten',
      CUSTOMER_COUNTER: 'Gegenangebot gesendet',
      ACCEPTED: 'Angenommen',
      REJECTED: 'Abgelehnt',
      EXPIRED: 'Abgelaufen',
      CONVERTED: 'Gebucht',
    },
  },
  excursionFlow: {
    catalogKicker: 'Sardinien · Erlebnisse',
    catalogTitlePart1: 'Was die',
    catalogTitleAccent: 'Insel',
    catalogTitlePart2: 'in Reiseführern nie erzählt.',
    catalogSubtitle: 'Geführte Routen und Aktivitäten lokaler Anbieter — Trekking, Bootstouren, Schnorcheln, Verkostungen.',
    catalogCounterLabel: 'Aktive Erlebnisse',
    catalogFilterAll: 'Alle',
    catalogEmptyTitle: 'Wir bereiten die nächsten Erlebnisse vor.',
    catalogEmptyBody: 'Die Ausflüge für die kommende Saison werden in Kürze veröffentlicht. In der Zwischenzeit kannst du die verfügbaren Mietboote durchstöbern.',
    catalogEmptyCta: 'Boote ansehen',
    catalogEmptyFilterTitle: 'Keine Ausflüge in dieser Kategorie.',
    catalogEmptyFilterBody: 'Entferne den Filter, um alle Erlebnisse zu sehen.',
    catalogEmptyFilterCta: 'Alle anzeigen',

    cardDiscover: 'Entdecken',
    cardFeaturedBadge: 'Hervorgehoben',
    cardOnRequest: 'Auf Anfrage',
    cardFrom: 'Ab',
    cardPerPerson: 'pro Person',
    cardPerGroup: 'pro Gruppe',
    cardMaxPeople: 'max',

    specialRequestCta: 'Sonderanfrage stellen',
    modalTitle: 'Sonderanfrage',
    modalTypeLabel: 'Art der Anfrage',
    typeTimeCustomLabel: 'Individuelle Uhrzeit',
    typeTimeCustomDesc: 'Gleiche Tour, andere Abfahrtszeit',
    typeGroupCustomLabel: 'Sondergröße Gruppe',
    typeGroupCustomDesc: 'Personenzahl außerhalb der Standardkapazität',
    typePrivateLabel: 'Private Tour',
    typePrivateDesc: 'Nur ihr, keine weiteren Teilnehmer',
    typeFullyCustomLabel: 'Maßgeschneiderte Erfahrung',
    typeFullyCustomDesc: 'Anderer Verlauf / Dauer / Inhalt',
    fieldDateStart: 'Wunschdatum',
    fieldDateEnd: 'Enddatum (falls mehrtägig)',
    fieldPeople: 'Personen',
    fieldMessage: 'Nachricht an den Anbieter',
    fieldMessagePlaceholder: 'Z.B. Wir möchten um 16:00 Uhr starten statt zur Standardzeit, wir sind eine Familie mit 2 Kindern im Alter von 8 und 10 Jahren…',
    fieldContactsHeading: 'Deine Kontaktdaten',
    fieldName: 'Vor- und Nachname',
    fieldEmail: 'E-Mail',
    fieldPhone: 'Telefon (optional)',
    btnCancel: 'Abbrechen',
    btnSendRequest: 'Anfrage senden',
    successTitle: 'Anfrage gesendet',
    successBody: 'Unser Anbieter wird benachrichtigt und antwortet dir per E-Mail an {email} mit einem persönlichen Angebot. Bitte prüfe auch den Spam-Ordner.',
    successCta: 'Verstanden',
    disclaimer: 'Du erhältst innerhalb weniger Stunden eine Antwort per E-Mail. Die Anfrage ist unverbindlich: du kannst das Angebot des Anbieters annehmen oder ablehnen.',

    magicHeroKicker: 'Sonderanfrage',
    magicHeroGreeting: 'Hallo {name}, hier ist das Angebot unseres Anbieters.',
    magicProposalLabel: 'Angebot des Anbieters',
    magicProposalTotal: 'gesamt',
    magicProposalWhen: 'Datum/Uhrzeit',
    magicProposalValidUntil: 'Gültig bis',
    magicProposalNotes: 'Details',
    magicAcceptCta: 'Annehmen und zahlen',
    magicRejectCta: 'Ablehnen',
    magicCounterCta: 'Gegenangebot',
    magicCounterTitle: 'Gegenangebot',
    magicCounterSubmit: 'Senden',
    magicAcceptConfirm: 'Bestätigst du die Annahme? Du wirst zur Zahlung weitergeleitet.',
    magicRejectPrompt: 'Grund (optional, für den Anbieter sichtbar):',
    magicRejectConfirm: 'Ablehnung bestätigen?',
    magicLinkExpiredTitle: 'Ungültiger Link',
    magicLinkExpiredBody: 'Anfrage nicht gefunden oder Link abgelaufen',
    magicMyRequest: 'Deine Anfrage',
    magicConversation: 'Konversation',
    magicMsgPlaceholder: 'Schreibe an den Anbieter…',
    magicValidUntilFooter: 'Link gültig bis zum {date}.',
    magicCreateAccount: 'Konto erstellen',
    magicCreateAccountSuffix: 'um alle Anfragen zu verwalten.',
    magicStatusAccepted: 'Angebot angenommen. Bitte zur Zahlung fortfahren.',
    magicStatusConverted: 'Zahlung abgeschlossen. Dein Ausflug ist bestätigt.',
    magicStatusRejected: 'Angebot abgelehnt.',
    magicStatusExpired: 'Anfrage abgelaufen.',
  },

  // ============================================
  // VENDOR DASHBOARD
  // ============================================
  vendor: {
    earningsByChannel: 'Einnahmen nach Kanal',
    // Dashboard
    dashboard: 'Dashboard',
    dashboardTitle: 'Anbieter-Dashboard',
    dashboardTitleCompany: 'Unternehmens-Dashboard',
    dashboardSubtitle: 'Verwalten Sie Ihre Boote und Buchungen',

    // Sidebar menu groups
    menuMain: 'Hauptmenü',
    menuFleet: 'Flotte',
    menuOperations: 'Betrieb',
    menuFinance: 'Finanzen',
    menuSettings: 'Einstellungen',
    // Sidebar menu items
    fleet: 'Boote',
    pricing: 'Preise',
    bulk: 'Sammelaktionen',
    suspensions: 'Sperrungen',
    extras: 'Zusatzleistungen',
    bookings: 'Buchungen',
    customRequests: 'Anfragen',
    clients: 'Kunden',
    reviews: 'Bewertungen',
    coupons: 'Gutscheine',
    team: 'Team',
    network: 'Netzwerk & Partner',
    earnings: 'Einnahmen',
    reports: 'Berichte',
    analytics: 'Analytics',
    notifications: 'Benachrichtigungen',
    profile: 'Profil',
    settings: 'Einstellungen',
    guide: 'Anleitung',
    roleVendor: 'Bootseigner',
    roleCompany: 'Unternehmen',

    // Navigation (legacy)
    myBoats: 'Meine Boote',
    myBookings: 'Eingegangene Buchungen',
    myEarnings: 'Einnahmen',
    myClients: 'Meine Kunden',
    myExtras: 'Zusatzleistungen',
    myProfile: 'Anbieterprofil',
    calendar: 'Kalender',

    // Tabs
    tabDashboard: 'Dashboard',
    tabMyBoats: 'Meine Boote',
    tabCalendar: 'Kalender',
    tabBookings: 'Buchungen',
    tabEarnings: 'Einnahmen',
    tabClients: 'Kunden',
    tabProfile: 'Profil',
    tabCompanyProfile: 'Unternehmensdaten',

    // Stats
    activeBoats: 'Aktive Boote',
    totalBookings: 'Buchungen',
    totalRevenue: 'Gesamteinnahmen',
    totalPayout: 'Netto-Auszahlung',
    platformFees: 'Plattformgebühren',
    bookingCount: 'Buchungen',
    netEarnings: 'Nettoeinnahmen',
    pendingPayout: 'Auszahlung ausstehend',
    paidOut: 'Bereits ausgezahlt',
    occupancyRate: 'Auslastungsrate',
    revenuePerBoat: 'Durchschn. Umsatz/Boot',
    loadingStats: 'Statistiken laden...',
    commissionUpdated: 'Provision aktualisiert',

    // Boat List
    loadingBoats: 'Boote laden...',
    noBoats: 'Keine Boote',
    noBoatsHint: 'Fügen Sie Ihr erstes Boot über das Admin-Dashboard hinzu',
    boatsCount: 'Boote',
    boatActive: 'Aktiv',
    boatInactive: 'Inaktiv',
    approvalApproved: 'Genehmigt',
    approvalPending: 'In Prüfung',
    approvalRejected: 'Abgelehnt',
    approvalNotes: 'Hinweise:',
    loadBoatsError: 'Fehler beim Laden der Boote',

    // Calendar
    calendarTitle: 'Buchungskalender',
    calendarSubtitle: 'Buchungen Ihrer Boote anzeigen und verwalten',
    loadingCalendar: 'Kalender laden...',
    noBoatsCalendar: 'Fügen Sie ein Boot hinzu, um den Kalender zu sehen',
    allBoats: 'Alle Boote',
    blockDates: 'Daten sperren',
    blockDatesTitle: 'Daten sperren',
    blockingFor: 'Sperrung für',
    startDate: 'Startdatum',
    endDate: 'Enddatum',
    blockReason: 'Grund (optional)',
    blockReasonPlaceholder: 'z.B.: Wartung, Privatnutzung...',
    blockWarning: 'Gesperrte Daten verhindern neue Buchungen für den ausgewählten Zeitraum',
    confirmBlock: 'Sperrung bestätigen',
    datesBlocked: 'Daten erfolgreich gesperrt',
    datesUnblocked: 'Daten entsperrt',
    blockError: 'Fehler beim Sperren der Daten',
    unblockError: 'Fehler beim Entsperren der Daten',
    selectBoatFirst: 'Wählen Sie zuerst ein Boot aus',
    selectDatesFirst: 'Wählen Sie die zu sperrenden Daten aus',
    blockedPeriods: 'Gesperrte Zeiträume',
    unblock: 'Entsperren',
    fleetOverview: 'Flottenübersicht',
    confirmed: 'bestätigt',
    pendingLabel: 'ausstehend',
    blocked: 'gesperrt',
    noBookingsYet: 'Keine Buchungen',
    calendarLoadError: 'Fehler beim Laden der Kalenderdaten',

    // Bookings
    loadingBookings: 'Buchungen laden...',
    allStatuses: 'Alle Status',
    pendingBookings: 'Ausstehend',
    confirmedRevenue: 'Bestätigter Umsatz',
    bookingsTitle: 'Buchungen',
    bookingsSubtitle: 'Buchungen verwalten',
    noBookingsFound: 'Keine Buchungen gefunden',
    allPaymentStatuses: 'Alle Zahlungen',
    paymentPending: 'Zu bezahlen',
    paymentPaid: 'Bezahlt',
    paymentPartial: 'Teilweise',
    paymentRefunded: 'Erstattet',
    calendarView: 'Kalender',
    listView: 'Liste',
    searchGuest: 'Kunde suchen...',
    downloadReceipt: 'Quittung herunterladen',
    reversibleBookings: 'Widerrufbare Buchungen',
    reversibleBookingsSubtitle: 'Sie können den vorherigen Status wiederherstellen',
    boatsOverview: 'Bootsübersicht',
    cancelWithReason: 'Mit Begründung stornieren',
    cancelConfirmMessage: 'Sind Sie sicher, dass Sie diese Buchung stornieren möchten?',
    cancelReasonPlaceholder: 'Grund der Stornierung (optional)',
    bookingDetail: 'Buchungsdetails',
    guestInfo: 'Kundeninformationen',
    boatInfo: 'Bootsinformationen',
    rentalDetails: 'Mietdetails',
    experienceDetails: 'Details zum Erlebnis',
    priceSummary: 'Preisübersicht',
    basePrice: 'Grundpreis',
    insuranceFee: 'Versicherung',
    specialRequests: 'Sonderwünsche',
    cancellationReason: 'Stornierungsgrund',
    reverse: 'Wiederherstellen',
    undo: 'Rückgängig',
    statusPending: 'Ausstehend',
    statusConfirmed: 'Bestätigt',
    statusCompleted: 'Abgeschlossen',
    statusCancelled: 'Storniert',
    noBookings: 'Keine Buchungen',
    boatFallback: 'Boot',
    guestFallback: 'Gast',
    nights: 'Nächte',
    guests: 'Gäste',
    netPayout: 'Netto:',
    loadBookingsError: 'Fehler beim Laden der Buchungen',

    // Earnings
    loadingEarnings: 'Einnahmen laden...',
    platformCommission: 'Plattformprovision',
    earningsDetail: 'Einnahmendetails',
    headerBoat: 'Boot',
    headerDates: 'Daten',
    headerTotal: 'Gesamt',
    headerCommission: 'Provision',
    headerNet: 'Netto',
    headerPayout: 'Auszahlung',
    payoutPaid: 'Bezahlt',
    payoutPending: 'Ausstehend',

    // Client Management
    searchClient: 'Kunde suchen...',
    noClients: 'Keine Kunden',
    noClientsHint: 'Kunden erscheinen hier nach der ersten Buchung',
    bookingsLabel: 'Buchungen',
    spentLabel: 'Ausgegeben',
    loadClientsError: 'Fehler beim Laden der Kunden',

    // Vendor Profile
    profileTitle: 'Anbieterprofil',
    profileUpdated: 'Profil erfolgreich aktualisiert',
    firstName: 'Vorname',
    firstNamePlaceholder: 'Max',
    lastName: 'Nachname',
    lastNamePlaceholder: 'Mustermann',
    phone: 'Telefon',
    phonePlaceholder: '+49 170 1234567',
    bio: 'Biografie',
    bioPlaceholder: 'Stellen Sie sich Ihren Kunden vor...',
    vendorBio: 'Biografie / Beschreibung',
    vendorPhone: 'Telefon',
    payoutData: 'Auszahlungsdaten',
    iban: 'IBAN',
    ibanPlaceholder: 'DE89370400440532013000',
    payoutIban: 'Auszahlungs-IBAN',
    accountHolder: 'Kontoinhaber',
    accountHolderPlaceholder: 'Max Mustermann',
    payoutHolder: 'Kontoinhaber',
    saveProfile: 'Profil speichern',
    loadProfileError: 'Fehler beim Laden des Profils',
    saveProfileError: 'Fehler beim Speichern',

    // Company Profile
    companyData: 'Unternehmensdaten',
    companyName: 'Firmenname',
    companyNamePlaceholder: 'Sardinia Charter GmbH',
    vatNumber: 'USt-IdNr.',
    companyVat: 'USt-IdNr.',
    vatPlaceholder: 'DE123456789',
    sdiCode: 'SDI-Code',
    companySdi: 'SDI-Code',
    sdiPlaceholder: 'M5UXCR1',
    pec: 'PEC',
    companyPec: 'PEC',
    pecPlaceholder: 'firma@pec.it',
    companyPhone: 'Firmentelefon',
    companyPhonePlaceholder: '+49 30 1234567',
    officeAddress: 'Geschäftsadresse',
    street: 'Straße',
    streetPlaceholder: 'Musterstraße 1',
    city: 'Stadt',
    cityPlaceholder: 'Olbia',
    province: 'Bundesland',
    provincePlaceholder: 'SS',
    postalCode: 'PLZ',
    postalCodePlaceholder: '07026',
    presentation: 'Vorstellung',
    companyBioPlaceholder: 'Beschreiben Sie Ihr Unternehmen für die Kunden...',
    saveCompanyProfile: 'Firmenprofil speichern',
    companyProfileUpdated: 'Firmenprofil aktualisiert',
    perDay: '/Tag',
    saving: 'Speichern...',

    // Booking as guest
    bookingOptions: 'Buchungsoptionen',
    canBookAsGuest: 'Ich möchte auch Boote buchen',
    canBookAsGuestDesc: 'Aktivieren Sie diese Option, um Boote anderer Anbieter als Kunde buchen zu können.',
    alsoClient: 'Auch Kunde',

    // Extras Management
    tabExtras: 'Zusatzleistungen',
    extrasTitle: 'Meine Zusatzleistungen',
    extrasSubtitle: 'Verwalten Sie die Zusatzleistungen für Ihre Boote',
    addExtra: 'Neues Extra',
    editExtra: 'Extra bearbeiten',
    noExtras: 'Keine Zusatzleistungen',
    noExtrasHint: 'Erstellen Sie Ihre erste Zusatzleistung, um sie Kunden anzubieten',
    extraKey: 'Schlüssel (eindeutige ID)',
    extraKeyPlaceholder: 'z.B.: skipper_service',
    extraLabel: 'Servicename',
    extraLabelPlaceholder: 'z.B.: Skipper-Service',
    extraDescription: 'Beschreibung',
    extraDescPlaceholder: 'Beschreiben Sie die Zusatzleistung...',
    extraPrice: 'Standardpreis (€)',
    extraPriceType: 'Preisart',
    pricePerStay: 'Pro Miete',
    pricePerDay: 'Pro Tag',
    pricePerPerson: 'Pro Person',
    pricePerPersonDay: 'Pro Person/Tag',
    extraStatusApproved: 'Genehmigt',
    extraStatusPending: 'In Prüfung',
    extraStatusRejected: 'Abgelehnt',
    approvalWarning: 'Die Bearbeitung eines genehmigten Extras sendet es erneut zur Admin-Genehmigung.',
    editResetsApproval: 'Die Bearbeitung eines genehmigten Extras setzt den Status auf "In Prüfung" zurück',
    extraCreated: 'Zusatzleistung erstellt. Wartet auf Genehmigung.',
    extraUpdated: 'Zusatzleistung aktualisiert',
    extraDeleted: 'Zusatzleistung gelöscht',
    extraSaveError: 'Fehler beim Speichern der Zusatzleistung',
    extraDeleteError: 'Fehler beim Löschen der Zusatzleistung',
    rejectionNotes: 'Ablehnungshinweise',
    loadExtrasError: 'Fehler beim Laden der Zusatzleistungen',
  },

  // ============================================
  // COMPANY DASHBOARD
  // ============================================
  company: {
    // Menu groups
    menuMain: 'Hauptmenü',
    menuFleet: 'Flottenverwaltung',
    menuOperations: 'Betrieb',
    menuFinance: 'Finanzen',
    menuSettings: 'Einstellungen',

    // Menu items
    overview: 'Übersicht',
    fleet: 'Flotte',
    calendar: 'Kalender',
    bookings: 'Buchungen',
    clients: 'Kunden',
    coupons: 'Gutscheine',
    team: 'Team',
    earnings: 'Einnahmen',
    reports: 'Berichte',
    analytics: 'Analytics',
    companyProfile: 'Firmenprofil',
    settings: 'Einstellungen',
    companyAccount: 'Firmenkonto',

    // Overview
    welcomeBack: 'Willkommen zurück, {name}',
    overviewSubtitle: 'Übersicht der Aktivitäten Ihres Unternehmens',
    recentBookings: 'Letzte Buchungen',
    viewAll: 'Alle anzeigen',
    quickActions: 'Schnellaktionen',
    quickFleet: 'Flotte verwalten',
    quickFleetDesc: 'Boote hinzufügen und verwalten',
    quickCalendar: 'Kalender',
    quickCalendarDesc: 'Verfügbarkeit und Buchungen anzeigen',
    quickReports: 'Berichte',
    quickReportsDesc: 'Einnahmen analysieren und Exporte erstellen',

    // Team
    teamSubtitle: 'Verwalten Sie Ihr Betriebsteam',
    teamComingSoon: 'Teamverwaltung in Kürze',
    teamComingSoonDesc: 'Bald können Sie Skipper, Mitarbeiter und Manager zu Ihrem Unternehmensteam hinzufügen.',
    plannedRoles: 'Geplante Rollen',
    roleSkipper: 'Skipper',
    roleSkipperDesc: 'Kapitäne für Ihre Boote',
    roleOperator: 'Mitarbeiter',
    roleOperatorDesc: 'Buchungs- und Kundenverwaltung',
    roleManager: 'Manager',
    roleManagerDesc: 'Flotten- und Betriebsaufsicht',

    // Reports
    reportsSubtitle: 'Detaillierte Einnahmenanalyse',
    dateFrom: 'Von',
    dateTo: 'Bis',
    clearFilters: 'Zurücksetzen',
    totalRevenue: 'Gesamteinnahmen',
    totalCommission: 'Provisionen',
    totalNet: 'Netto',
    noReportData: 'Keine Daten für den ausgewählten Zeitraum',
    checkIn: 'Einschiffung',
    checkOut: 'Ausschiffung',
    nights: 'Nächte',

    // Export
    exportCSV: 'CSV exportieren',
    exportPDF: 'PDF exportieren',
    comingSoon: 'Demnächst',
  },

  // Promo overlay (public)
  promo: {
    close: 'Schließen',
    discover: 'Entdecken',
    bookNow: 'Jetzt buchen',
    prev: 'Zurück',
    next: 'Weiter',
  },

  // Service Provider System
  sp: {
    dashboardTitle: 'Meine Dienste',
    dashboardSubtitle: 'Verwalten Sie Ihre Serviceanfragen',
    role: 'Dienstleister',
    tabStats: 'Statistiken',
    tabRequests: 'Anfragen',
    tabProfile: 'Profil',
    statsPending: 'Ausstehend',
    statsAccepted: 'Akzeptiert',
    statsCompleted: 'Abgeschlossen',
    statsRevenue: 'Monatlicher Umsatz',
    statusPENDING: 'Ausstehend',
    statusBROADCAST: 'Broadcasting',
    statusACCEPTED: 'Akzeptiert',
    statusCOMPLETED: 'Abgeschlossen',
    statusREJECTED: 'Abgelehnt',
    statusCANCELLED: 'Storniert',
    statusEXPIRED: 'Abgelaufen',
    noRequests: 'Keine Serviceanfragen',
    requestDetail: 'Anfragedetail',
    boat: 'Boot',
    guest: 'Gast',
    guestPhone: 'Gast-Telefon',
    passengers: 'Passagiere',
    pickupDate: 'Abholdatum',
    returnDate: 'Rückfahrtdatum',
    pickup: 'Abholort',
    dropoff: 'Ziel',
    specialRequests: 'Sonderwünsche',
    rejectionReason: 'Ablehnungsgrund',
    rejectionReasonPlaceholder: 'Ablehnungsgrund eingeben...',
    notes: 'Interne Notizen',
    notesPlaceholder: 'Notizen hinzufügen...',
    saveNotes: 'Notizen speichern',
    accept: 'Akzeptieren',
    reject: 'Ablehnen',
    complete: 'Abschließen',
    confirmReject: 'Ablehnung bestätigen',
    profileBasic: 'Grundinformationen',
    name: 'Name',
    phone: 'Telefon',
    license: 'Lizenznummer',
    licensePlaceholder: 'Z.B. OT/12345',
    bio: 'Beschreibung',
    fleet: 'Fahrzeugflotte',
    fleetSize: 'Anzahl Fahrzeuge',
    maxPassengers: 'Max. Passagiere',
    vehicleTypes: 'Fahrzeugtypen',
    vehiclePlaceholder: 'Z.B. Limousine, 8-Sitzer Minivan',
    serviceArea: 'Servicegebiete',
    serviceAreaPlaceholder: 'Z.B. Olbia, Porto Cervo',
    operatingHours: 'Betriebszeiten',
    saveProfile: 'Profil speichern',
    // Calendar tab
    tabCalendar: 'Kalender',
    calendarTitle: 'Terminkalender',
    calendarRequests: 'Anfragen',
    // Extras tab
    tabExtras: 'Dienste',
    myExtras: 'Meine Dienste',
    createExtra: 'Neuer Dienst',
    editExtra: 'Dienst bearbeiten',
    extrasEmpty: 'Keine Dienste erstellt',
    extraPendingInfo: 'Neue Dienste werden zur Genehmigung gesendet. Das Bearbeiten eines genehmigten Dienstes setzt ihn auf Überprüfung zurück.',
    extraEditWarning: 'Das Bearbeiten eines genehmigten Dienstes setzt ihn auf "In Überprüfung" für eine erneute Genehmigung zurück.',
    extraDeleteConfirm: 'Sind Sie sicher, dass Sie löschen möchten',
    extraApproved: 'Genehmigt',
    extraPendingReview: 'In Überprüfung',
    extraRejected: 'Abgelehnt',
    extraKeyLabel: 'Schlüssel (eindeutige ID)',
    extraNameLabel: 'Dienstname',
    extraDescLabel: 'Beschreibung',
    extraPriceLabel: 'Standardpreis (€)',
    extraPriceTypeLabel: 'Preistyp',
    extraSave: 'Änderungen speichern',
    extraCategory: 'Kategorie',
    extraCategoryMobility: 'Mobilität (Verleih & Transfer)',
    extraCategoryOther: 'Anderer Service',
    extraPorts: 'Betriebshäfen *',
    extraPortsHint: 'Wählen Sie die Häfen aus, in denen Sie diesen Service anbieten. Kunden sehen den Service nur für Boote, die in diesen Häfen liegen.',
    extraPortsEmpty: 'Keine Häfen verfügbar',
    extraPortsRequired: 'Wählen Sie mindestens einen Betriebshafen aus',
    extraPortsSelectedOne: 'Hafen ausgewählt',
    extraPortsSelectedMany: 'Häfen ausgewählt',
    extraOperatingAt: 'Aktiv in',
    pricingMode: 'Preismodus',
    pricingModeFixed: 'Festpreis',
    pricingModeQuote: 'Auf Anfrage (Angebot)',
    pricingModeQuoteHint: 'Kunden fordern ein Angebot an, statt einen Preis zu sehen. Sie erhalten jede Anfrage in Ihrem Dashboard.',
    priceNotApplicable: 'Nicht anwendbar',
    // Marketplace broadcast (Phase 1)
    broadcastTitle: 'Live-Marktplatz',
    broadcastHint: 'Wer zuerst annimmt, gewinnt den Auftrag. Sei schnell!',
    claimNow: 'Sofort annehmen',
    claimSuccess: 'Anfrage angenommen!',
    claimLost: 'Bereits von einem anderen Anbieter übernommen',
    // Empty state — new SP with no linked ServiceProvider profile yet
    noProfileYet: 'Sie haben noch kein aktives Anbieterprofil',
    noProfileHint: 'Warten Sie, bis der Admin Ihnen einen Service zuweist, oder abonnieren Sie eine Servicevorlage im Tab „Meine Angebote", um Marketplace-Anfragen zu erhalten.',
    pendingApprovalTitle: 'Konto wartet auf Genehmigung',
    pendingApprovalMessage: 'Ihr Konto wird überprüft. Sie werden benachrichtigt, wenn es genehmigt wird.',
    // Generic service keys
    serviceType: 'Servicetyp',
    bikeRental: 'Fahrradverleih',
    ebikeRental: 'E-Bike-Verleih',
    scooterRental: 'Rollerverleih',
    monopattinoRental: 'E-Scooter-Verleih',
    transferPorto: 'Hafentransfer',
    allServices: 'Alle Dienste',
    filterByService: 'Nach Service filtern',
    requestFrom: 'Anfrage von',
    quantity: 'Menge',
    serviceDate: 'Servicedatum',
    providerNotes: 'Anbieternotizen',
    // Error / toast messages
    errLoadRequests: 'Serviceanfragen können nicht geladen werden',
    errLoadStats: 'Statistiken können nicht geladen werden',
    errLoadCalendar: 'Kalender kann nicht geladen werden',
    errLoadProfile: 'Profil kann nicht geladen werden',
    errSaveProfile: 'Profil kann nicht gespeichert werden',
    errAcceptRequest: 'Anfrage kann nicht angenommen werden',
    errRejectRequest: 'Anfrage kann nicht abgelehnt werden',
    errCompleteRequest: 'Anfrage kann nicht abgeschlossen werden',
    errSaveNotes: 'Notizen können nicht gespeichert werden',
    profileSaved: 'Profil erfolgreich gespeichert',
    notesSaved: 'Notizen gespeichert',
    capacityCheck: 'Automatische Kapazitätsprüfung',
    capacityCheckEnabled: 'Automatische Sperre aktiv',
    capacityCheckDisabled: 'Automatische Sperre deaktiviert',
    capacityCheckHintEnabled: 'Wenn aktiviert, lehnt das System neue Anfragen automatisch ab, wenn die für dieses Datum konfigurierte Höchstkapazität bereits erreicht ist.',
    capacityCheckHintDisabled: 'Sie erhalten alle Anfragen auch über die konfigurierte Kapazität hinaus und verwalten eventuelle Konflikte manuell.',
    capacityCheckSaved: 'Kapazitätseinstellung aktualisiert',
    capacityExhausted: 'Der Anbieter hat keine Verfügbarkeit für das angeforderte Datum',
    // Payment collection mode
    paymentMode: 'Zahlungseinzugsmodus',
    paymentModeFull: 'Plattform zieht alles ein',
    paymentModeFullDesc: 'Die Plattform berechnet den vollen Buchungsbetrag und überweist Ihnen den Nettobetrag per Banküberweisung.',
    paymentModeCommissionOnly: 'Plattform zieht nur die Provision ein',
    paymentModeCommissionDesc: 'Die Plattform berechnet nur ihre Provision. Der Restbetrag wird vom Gast direkt beim Check-in an Sie gezahlt (bar oder POS).',
    paymentModeFullHint: 'Standardmodus: Alles läuft über die Plattform und Sie erhalten den Nettobetrag per Banküberweisung.',
    paymentModeCommissionHint: 'In diesem Modus zahlen Gäste den Restbetrag direkt am Hafen an Sie. Die Plattform behält nur ihren Anteil ein.',
    spIban: 'Auszahlungs-IBAN',
    spIbanHolder: 'Kontoinhaber',
    paymentModeSaved: 'Zahlungseinzugsmodus gespeichert',
    // SP catalog (offers tab)
    tabOffers: 'Meine Angebote',
    offersTitle: 'Angebotskatalog',
    offersDesc: 'Abonniere vom Admin erstellte Servicevorlagen mit deinen eigenen Preisen',
    offersAdd: 'Angebot hinzufügen',
    offersEdit: 'Angebot bearbeiten',
    offersDelete: 'Angebot löschen',
    offersSelectTemplate: 'Vorlage auswählen',
    offersCustomPrice: 'Eigener Preis',
    offersCapacity: 'Kapazität',
    offersNotes: 'Notizen',
    offersPorts: 'Einsatzhäfen',
    offersEmpty: 'Keine aktiven Angebote. Füge eins hinzu, um loszulegen.',
    offersNoTemplates: 'Keine Vorlagen verfügbar. Der Admin muss mindestens eine erstellen.',
    offersCreated: 'Angebot erstellt',
    offersUpdated: 'Angebot aktualisiert',
    offersDeleted: 'Angebot gelöscht',
  },

  // ============================================
  // SERVICES SUBDOMAIN
  // ============================================
  servicesLogin: {
    title: 'Insula Services',
    subtitle: 'Dienstleister-Bereich',
    sectionLabel: 'Dienstleister-Zugang',
    submit: 'Anmelden',
    submitting: 'Anmeldung läuft...',
    accessDenied: 'Dieser Bereich ist Dienstleistern vorbehalten.',
    copyright: 'Alle Rechte vorbehalten.',
  },
  servicesCatalog: {
    title: 'Verfügbare Dienstleistungen',
    subtitle: 'Unsere lokalen Servicepartner',
    noProviders: 'Derzeit keine Anbieter verfügbar',
    becomeProvider: 'Anbieter werden',
    requestService: 'Service anfragen',
    serviceArea: 'Servicegebiete',
    vehicleTypes: 'Fahrzeuge',
    maxPassengers: 'Max. Passagiere',
    howItWorks: 'So funktioniert es',
    howItWorksDesc: 'Buchen Sie einen Bootsausflug und fügen Sie den Transferservice hinzu. Ein lokaler Anbieter kümmert sich um Ihren Transport.',
  },
  servicesNavbar: {
    dashboard: 'Dashboard',
    catalog: 'Servicekatalog',
    login: 'Anmelden',
    logout: 'Abmelden',
  },

  // ============================================
  // SP SELF-REGISTRATION WIZARD
  // ============================================
  spReg: {
    title: 'Dienstleister werden',
    subtitle: 'Registrieren Sie sich in wenigen Schritten auf Insula Services.',
    becomeProvider: 'Anbieter werden',
    step1Title: 'Konto',
    step2Title: 'Unternehmensdaten',
    step3Title: 'Kategorien & Häfen',
    step4Title: 'Zusammenfassung',
    next: 'Weiter',
    previous: 'Zurück',
    submit: 'Antrag senden',
    fieldName: 'Vor- und Nachname',
    fieldEmail: 'E-Mail',
    fieldPassword: 'Passwort',
    fieldPasswordConfirm: 'Passwort bestätigen',
    fieldPhonePrefix: 'Vorwahl',
    fieldPhoneNumber: 'Telefon',
    fieldCompanyName: 'Firmenname',
    fieldVAT: 'USt-IdNr.',
    fieldTaxCode: 'Steuernummer',
    fieldAddress: 'Adresse',
    fieldCity: 'Stadt',
    fieldProvince: 'Provinz',
    fieldPostalCode: 'PLZ',
    selectCategories: 'Angebotene Servicekategorien',
    selectPorts: 'Betriebshäfen',
    summaryTitle: 'Daten überprüfen',
    summaryHint: 'Bitte prüfen Sie alle Angaben vor dem Absenden der Registrierung.',
    successTitle: 'Antrag gesendet',
    successMessage: 'Ihre Registrierung wurde empfangen. Ein Administrator wird sie in Kürze prüfen und Sie per E-Mail benachrichtigen.',
    errors: {
      required: 'Dieses Feld ist erforderlich',
      emailInvalid: 'Ungültige E-Mail',
      passwordWeak: 'Das Passwort muss mindestens 8 Zeichen enthalten',
      passwordMismatch: 'Die Passwörter stimmen nicht überein',
      selectCategory: 'Wählen Sie mindestens eine Kategorie aus',
      selectPort: 'Wählen Sie mindestens einen Hafen aus',
      emailExists: 'Diese E-Mail ist bereits registriert',
      generic: 'Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.',
    },
  },

  boatWizard: {
    useType: {
      label: 'Verwendungszweck',
      locazione: { label: 'Vermietung', desc: 'Selbstfahrer-Vermietung (Bareboat): erscheint im Vermietungskatalog' },
      excursionOnly: { label: 'Nur Ausflüge', desc: 'Nur für Ausflüge/Erlebnisse genutzt, nicht im Vermietungskatalog' },
    },
    pricingMode: {
      label: 'Preismodus',
      fixed: { label: 'Festpreis', desc: 'Sichtbare Preise: Kunden sehen die Preise und konnen direkt buchen' },
      quoteOnRequest: { label: 'Preis auf Anfrage', desc: 'Kunden senden eine Angebotsanfrage; Sie antworten mit einem individuellen Preis' },
      priceFieldsHidden: 'Preisfelder sind ausgeblendet, da das Boot auf "Preis auf Anfrage" eingestellt ist.',
    },
  },

};

export default de;
